var getRestaurantOrders;
var getRestaurantClosedOrders;
var orderplacedDate;
var orderToOpen;
var resOrders;
let listOrderOpened = [];
let listOrderTimeOpened = [];
let currentOrderId = null;
let listOrders = null;
let isChangedDate = false;
let isChangeOrderStatus = false;
let coustomerInRestaurant;

// $(document).ready(function(){
  if(window.location.href.indexOf("orderplacedDate") > -1 && (window.location.href.indexOf("orderToOpen") > -1 || window.location.href.indexOf("orderId") > -1)) {
        let url = new URL(window.location.href);
        orderplacedDate = url.searchParams.get('orderplacedDate');
        orderToOpen = url.searchParams.get('orderToOpen') || url.searchParams.get('orderId');
  }
// });
$(function() {
  var VENUEID = $('#venueId').val();
  var USER_ID = $.trim($('#user-id').html());
  var ORDER_ID = $('#orderId').length ? $('#orderId').val() : '';
  const UTC_OFFSET = +$('#restaurant-utc-offset').val();
  var $restaurantorder = $('#collapseRestaurantOrder');
  const userPermissions = $('#userPermissions').val();
  change_order_status()
	getServerRequests();
  let checkState = $(".open-restaurant-orders").hasClass('active')

  $(".open-restaurant-orders").click(function(){
      getRestaurantOrders();
      getRestaurantClosedOrders();
      // $(this).unbind('click');
  })

  let url = new URL(window.location.href);
  let show = url.searchParams.get('show') || false;

  $('body').on('change', '#servername-drop', function () {
    getRestaurantOrders();
    //resetFetchInterval();
  });

  let orderFormDate = new Date();
  let orderToDate = new Date();
  // close order date


  $('#closed-order-from-date').datetimepicker({
    format:  'MM/DD/YYYY LT',
    useCurrent: false,
    defaultDate: orderplacedDate ? moment(orderplacedDate).subtract(2, 'days').startOf('day') : moment().startOf('day'),
  }).on('dp.change', function(e){
    var selectedDate = new Date(e.date);
    orderFormDate = selectedDate;
    $("#order-to-date").data('DateTimePicker').minDate(selectedDate);
    handleChangeDate(true)
  });
  let to_date = new Date();
  to_date.setDate(to_date.getDate() + 1);
  $('#closed-order-to-date').datetimepicker({
    format:  'MM/DD/YYYY LT',
    useCurrent: false,
    defaultDate: orderplacedDate ?  moment(orderplacedDate).add(1, 'days').format('MM/DD/YYYY LT') : moment().add(1, 'days').hour(4).minutes(0),
  }).on('dp.change', function(e){
    var selectedDate = new Date(e.date);
    orderToDate = selectedDate;
    $("#order-from-date").data('DateTimePicker').maxDate(selectedDate);
    handleChangeDate(true)
  });




  $('#order-from-date').datetimepicker({
    format:  'MM/DD/YYYY LT',
    useCurrent: false,
    defaultDate: orderplacedDate ? moment(orderplacedDate).subtract(2, 'days').startOf('day') : moment().startOf('day'),
  }).on('dp.change', function(e){
    var selectedDate = new Date(e.date);
    orderFormDate = selectedDate;
    
    $("#order-to-date").data('DateTimePicker').minDate(selectedDate);
    handleChangeDate(false)
  });
  let t_date = new Date();
  t_date.setDate(t_date.getDate() + 1);
  $('#order-to-date').datetimepicker({
    format:  'MM/DD/YYYY LT',
    useCurrent: false,
    defaultDate: orderplacedDate ?  moment(orderplacedDate).add(1, 'days').format('MM/DD/YYYY LT') : moment().add(1, 'days').hour(4).minutes(0),
  }).on('dp.change', function(e){
    var selectedDate = new Date(e.date);
    orderToDate = selectedDate;
     $("#order-from-date").data('DateTimePicker').maxDate(selectedDate);
    handleChangeDate(false)
  });

  $('#icon-order-from-date').click(function(){
    $('#order-from-date').trigger('focus')
  })
  $('#icon-order-to-date').click(function() {
    $('#order-to-date').trigger('focus')
  })
  $('#icon-closed-order-date').click(function() {
    $('#closed-order-date').trigger('focus')
  })

   $('#order-from-hour, #order-from-minute, #order-from-apm, #order-to-hour, #order-to-minute, #order-to-apm').on('change', function(){
    handleChangeDate()
  })

  let timout = null;
  function handleChangeDate(closeorder) {
    clearTimeout(timout);
    isChangedDate = true;
    
    timout = setTimeout(() => {
      if(closeorder==true){
         getRestaurantClosedOrders();
      }else{
        getRestaurantOrders();
      }
      
     
      //resetFetchInterval();
    }, 1500);
  }

  function formatOrderDate() {
    const fromDate = $('#order-from-date').val();
    const toDate = $('#order-to-date').val();
    const from_date_time = moment(`${fromDate}`, 'MM/DD/YYYY hh:mma').utcOffset(UTC_OFFSET);
    const to_date_time = moment(`${toDate}`, 'MM/DD/YYYY hh:mma').utcOffset(UTC_OFFSET);
    const closefromDate = $('#closed-order-from-date').val();
    const closetoDate = $('#closed-order-to-date').val();
    const close_from_date_time = moment(`${closefromDate}`, 'MM/DD/YYYY hh:mma').utcOffset(UTC_OFFSET);
    const close_to_date_time = moment(`${closetoDate}`, 'MM/DD/YYYY hh:mma').utcOffset(UTC_OFFSET);
    
    return {
      orderFormDate: from_date_time.utc(),
      orderToDate: to_date_time.utc(),
      orderCloseFormDate: close_from_date_time.utc(),
      orderCloseToDate: close_to_date_time.utc()


    }
  }
  let listservers = [];
  let list_deliverer = [];
  let listadmins = [];
  let list_greeters = [];
  function getWaitstaff(){
    if(_.size(listservers) || _.size(listadmins)) return setWaitstaff()
    return $.ajax({
      url: `/restaurantadmin/listyourwaitstaff/${VENUEID}`,
      method: 'GET',
      contentType: 'application/json; charset=utf-8',
      success: function (results) {
        listservers = results.serversList || [];
        listadmins = results.adminList || [];
        list_deliverer = results.deliveryStaffList || [];
        list_greeters = results.listOfGreeters || [];
        return setWaitstaff()
      }
    })
  }
  $('body').on('click', '.restaurant-order-tree', function() {
    getWaitstaff();
    $(this).unbind('click')
  })

	function getServerRequests(){
		let urgentReqs = [];
		let nonUrgentReqs = [];
		 $.ajax({
      url: `/restaurantadmin/getServerRequests`,
      method: 'GET',
      contentType: 'application/json; charset=utf-8',
      success: function (results) {
				if(results.data && results.data.length > 0){
					let html = `<div class="form-row col-8">`;
					results.data.forEach((item) => {
						if(item && item.isUrgent){
							urgentReqs.push(item);
						} else {
							nonUrgentReqs.push(item);
						}
					});
					if(urgentReqs && urgentReqs.length > 0){
						html += `<label class="col-12">Customers Requesting you Urgently:</label>`;
						urgentReqs.reverse().forEach((item)=>{
							html += `<div class="form-group col-12 text-right"><span>${item.customerName}, ${moment(item.created_at).format("hh:mm A")} (${moment(item.created_at).format("MM/DD/YYYY")})<span> <button class="btn btn-default ml-3 removeRequest" data-venueId="${item.venueId}" data-orderId="${item.orderId}" data-customerId="${item.customerId}" data-urgentType="${item.isUrgent}">Dismiss</button></div>`;
						});
					}

					if(nonUrgentReqs && nonUrgentReqs.length > 0){
						html += `<label class="col-12">When time Permits:</label>`;
						nonUrgentReqs.reverse().forEach((item)=>{
							html += `<div class="form-group col-12 text-right"><span>${item.customerName}, ${moment(item.created_at).format("hh:mm A")} (${moment(item.created_at).format("MM/DD/YYYY")})<span> <button class="btn btn-default ml-3 removeRequest" data-venueId="${item.venueId}" data-orderId="${item.orderId}" data-customerId="${item.customerId}" data-urgentType="${item.isUrgent}">Dismiss</button></div>`;
						});
					}

					html +=`</div><hr/>`;
					$("#serverOrders").html(html);
				}
      }
    })
	}

  function setWaitstaff(){
    $.each($('.cliam_person'), function(index, element){
      let server_id = $(element).data('server-id')
      let option = `<option value="">Please select</option>`;
      $.each(listservers, function(key, value) {
        let seleted = server_id == value.id ? 'selected': '';
        option += `<option data-type='waitstaff' value="${value.id}" ${seleted} >${value.name} - Waitstaff</option>`;
      })

      $.each(list_deliverer, function(key, value) {
        let seleted = server_id == value.id ? 'selected': '';
        option += `<option data-type='deliverer' value="${value.id}" ${seleted} >${value.name} - Deliverer</option>`;
      })

      $.each(listadmins, function(key, value) {
        let seleted = server_id == value._id  ? 'selected': '';
        let adminName = value.profile && value.profile.contactInfo ? (value.profile.contactInfo.firstName || '') +' '+ (value.profile.contactInfo.lastName || '') : '';
        if(adminName.trim() == '') {
          adminName = value.local.email;
        }
        option += `<option data-type='admin' value="${value._id}" ${seleted} >${adminName} - Admin</option>`;
      })
      return $(element).html(option);
    })
  }
  //get close order
   getRestaurantClosedOrders = function (orderId_render = false, updateAll = true, isUrl = false){
   let getClosedOrder=true;
    let isLogin = $('#is-logged-in').val() ? true : false;
    if(!isLogin){
      return;
    }
    let venueId = VENUEID;
    let orderTypes = [];
    let serverId = $('#servername-drop').val();
    $("#fetch-restaurant-orders-message").html('');

    let today  = moment.utc();

    $( ".order-type-li.active" ).each(function() {
      let type = $(this).find(".restaurant-order-type").data("type");
      orderTypes.push(type);
    });

    if(ORDER_ID && Number(ORDER_ID) > 0 || ( orderId_render  && isUrl)) {
      let data = {
        venueId : venueId,
        orderId: orderId_render,
      };
      return $.ajax({
        url: '/orders/getRestaurantOrderById',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        error: function(err) {
          $('#loading-icon').fadeOut( "slow");
          Swal.fire('Unable to get orders', 'Please Try Again!', 'error');
        },
        success: function(res) {
          $('#loading-icon').fadeOut( "slow");
          if(res.data && res.data.length) {
            renderOrdersList(res.data, orderId_render, updateAll);
            $('html, body').animate({ scrollTop: $('#restaurant-orders-container').offset().top - 100 }, 100);
          } else {
            renderNotFoundOrder();
          }
        }
      })
    } else if(!ORDER_ID) {
      if (orderTypes.includes('waitlist')){

      } else {
          const { orderCloseFormDate, orderCloseToDate } = formatOrderDate();
          var data = {
            venueId : venueId,
            orderTypes: orderTypes,
            date: today,
            fromDate: orderCloseFormDate,
            toDate: orderCloseToDate,
            serverId: serverId,
            getClosedOrder:getClosedOrder
          };
       
        
        
        return $.ajax({
          url: '/orders/getRestaurantOrders',
          type: 'POST',
          data: JSON.stringify(data),
          contentType: 'application/json',
          dataType: 'json',
          error: function(err) {
            $("#fetch-restaurant-orders-message").html(`<p class="white" style="padding: 5px;">Unable to fetch new orders. Please try again.</p>`);
            $("#fetch-restaurant-orders-button").html(`<button id="reload-closerestaurant-orders" class="btn btn-primary" style="padding: 5px 32px;">Refresh</button>`);
          },
          success: function(res) {
            console.log("res====",res)
            renderClosedOrdersList(res.data);
            resOrders = res;

            if(resOrders && orderToOpen) {
              // $(`#collapse_rOrdersList_${list_index}`).collapse("show");
              let index = $(`#item-list-order-${orderToOpen}`).data('index')
              $(`#collapse_rOrdersList_${index}`).collapse("show");
            }
          }
        })
      }
    }
  }



  getRestaurantOrders = function (orderId_render = false, updateAll = true, isUrl = false){
    let isLogin = $('#is-logged-in').val() ? true : false;
    if(!isLogin){
      return;
    }
    let venueId = VENUEID;
    let orderTypes = [];
    let serverId = $('#servername-drop').val();

    $("#fetch-restaurant-orders-message").html('');

    let today  = moment.utc();

    $( ".order-type-li.active" ).each(function() {
      let type = $(this).find(".restaurant-order-type").data("type");
      orderTypes.push(type);
    });

    if(ORDER_ID && Number(ORDER_ID) > 0 || ( orderId_render  && isUrl)) {
      let data = {
        venueId : venueId,
        orderId: orderId_render,
      };
      return $.ajax({
        url: '/orders/getRestaurantOrderById',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        error: function(err) {
          $('#loading-icon').fadeOut( "slow");
          Swal.fire('Unable to get orders', 'Please Try Again!', 'error');
        },
        success: function(res) {
          $('#loading-icon').fadeOut( "slow");
          if(res.data && res.data.length) {
            renderOrdersList(res.data, orderId_render, updateAll);
            $('html, body').animate({ scrollTop: $('#restaurant-orders-container').offset().top - 100 }, 100);
          } else {
            renderNotFoundOrder();
          }
        }
      })
    } else if(!ORDER_ID) {
      if (orderTypes.includes('waitlist')){

      } else {
       
           const { orderFormDate, orderToDate } = formatOrderDate();
           var data = {
              venueId : venueId,
              orderTypes: orderTypes,
              date: today,
              fromDate: orderFormDate,
              toDate: orderToDate,
              serverId: serverId
            };
       
        
        
        return $.ajax({
          url: '/orders/getRestaurantOrders',
          type: 'POST',
          data: JSON.stringify(data),
          contentType: 'application/json',
          dataType: 'json',
          error: function(err) {
            $("#fetch-restaurant-orders-message").html(`<p class="white" style="padding: 5px;">Unable to fetch new orders. Please try again.</p>`);
            $("#fetch-restaurant-orders-button").html(`<button id="reload-restaurant-orders" class="btn btn-primary" style="padding: 5px 32px;">Refresh</button>`);
          },
          success: function(res) {
           
              renderOrdersList(res.data, orderId_render, updateAll);
           
            resOrders = res;

            if(resOrders && orderToOpen) {
              // $(`#collapse_rOrdersList_${list_index}`).collapse("show");
              let index = $(`#item-list-order-${orderToOpen}`).data('index')
              $(`#collapse_rOrdersList_${index}`).collapse("show");
            }
          }
        })
      }
    }
  }
  
  coustomerInRestaurant = function (data){
    if (!data._data.popup) return
    Swal.fire({
      title: data._data.popup,
      icon: data.popupType || 'success',
      showCancelButton: false,
      confirmButtonColor: '#4CAF50',
      confirmButtonText: 'OK'
    }).then((result) => {
       
      console.log("redirecting from alerttouser....", data);

      if(data.reload_page) window.location.reload();
    })
  }
  const AlertToUserRateOrder = (data) => {
    if (!data.popup) return
    Swal.fire({
        title: data.popup,
        icon: data.popupType || 'success',
        showCancelButton: false,
        confirmButtonColor: '#02843d',
        confirmButtonText: 'OK'
    }).then((result) => {
        if (result.isConfirmed) {
        if(data.reload_page) window.location.reload();
    }
    })
};
  let page_log = {}
  try{
      page_log = JSON.parse(localStorage.page_log)
      if(page_log.open_tab == '#restaurant-orders') {
        getRestaurantOrders()
        getRestaurantClosedOrders();
        
      }
  }catch(err){

  }

  if(!show && ORDER_ID) {
    getRestaurantOrders();
  }

  // let RefreshOrderInterval;
  // function resetFetchInterval(){
  //   if (userPermissions && (
  //         userPermissions.includes("PlateRate Admin")
  //         || userPermissions.includes("Restaurant Admin")
  //         || userPermissions.includes("Salesperson")
  //       )
  //     )
  //   {
  //     if (RefreshOrderInterval) clearInterval(RefreshOrderInterval);
  //     RefreshOrderInterval = setInterval(getRestaurantOrders, 60000);
  //   }
  // }

  // resetFetchInterval()

  $("body").on("click","#reload-restaurant-orders, #reload-closerestaurant-orders", function(){  
    getRestaurantClosedOrders();
    getRestaurantOrders();
  });

  function checkLogin(){
    let isLogin = $('#is-logged-in').val() ? true : false;
    if(!isLogin){
      Swal.fire({
        title: "Login Required",
        text: "Please login to view order.",
        icon: "info",
        allowOutsideClick: true,
        confirmButtonText: "Login or Register",
        confirmButtonColor: "#3cb371",
      }).then((result) => {
          if (result.isConfirmed) {
       
          let urllogin = '/users/login';
          if(window.location.pathname && (window.location.pathname != urllogin && window.location.pathname != '/')) {
            urllogin = urllogin+'?next='+window.location.pathname + window.location.search;
            // if(action) saveAction(action);
          }
          window.location.assign(urllogin);
        }
      });
      return false;
    }else{
      return true;
    }
  }

  function renderNotFoundOrder() {
    let notfound = `<div class="alert alert-danger fade in alert-dismissible">
                        <strong>Not found!</strong> There are no orders.
                    </div>`;
    // $("#restaurant-orders-container").html(notfound);
  }

  $("#refresh-restaurant-order-waitlist").click(e => {
    refreshRestaurantWaitlistTable(VENUEID)
  })

  const refreshRestaurantWaitlistTable = (venueId) => {
    return $.promisedAjax({
      url: `/orders/waitlist-restaurant/get-queue?venueId=${venueId}`,
      type: 'GET',
      contentType: 'application/json',
      dataType: 'json'
    }).then(res => {
      if ($.fn.DataTable.isDataTable("#restaurant-waitlist-queue")) {
        $("#restaurant-waitlist-queue").dataTable().fnDestroy();
      }
      $("#restaurant-waitlist-queue tbody").html("")

      var table = $('#restaurant-waitlist-queue').DataTable({
        ordering: false,
        retrieve: true,
        data: res.data,
        language: {
          emptyTable: "There are currently no orders in waitlist."
        },
        columns: [
          { data: 'order_name',
            render: function ( data, type, row, meta ) {
               return `${meta.row+1}. ${data}`
            }
          },
          { data: 'party_size' },
          { data: 'estimated_wait_mins' },
          { data: 'estimated_seating_time',
            render: function ( data, type, row, meta ) {
               return moment(data).format("hh:mm A")
            }
          },
          { data: 'added_to_waitlist_at',
            render: function ( data, type, row, meta ) {
               return moment(data).format("hh:mm A")
            }
          },

          { data: 'vip_skip_ahead_status' },
          { data: 'spend_to_date' },
          { data: 'spend_past_month' },
          { data: 'historical_spend_per_hour_per_person' },
          { data: 'historical_spend_per_reservation_per_person', width : "25px" },
          { data: 'average_tip' },

          { data: null },
        ],
        createdRow: function (row, data, index) {
          let btn = ``
          if (data.seated_at){
            btn = `<span style="font-size: inherit;">Seated</span>`
          } else if (data.state == "approved"){
            btn = `<button type="button" class="btn btn-lg waitlist-seat" data-order-id="${data.order_id}">Seat</button>`
          } else {
            btn = `<span style="font-size: inherit;">Not ready</span>`
          }
          $(row).css("background-color", "lightgray")
          $('td', row).eq(-1).html(btn).css('text-align', 'center')
        },
      });
    })
  }

  $('#collapseRestaurantOrder').on('click', '.waitlist-seat', e => {
    let $target = $(e.currentTarget)
    let orderId = $target.data('order-id')
    let data = {
      orderId : orderId,
      venueId : VENUEID
    }
    return $.promisedAjax({
      url: `/orders/waitlist-restaurant/seat`,
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      dataType: 'json'
    }).then(res => {
      refreshRestaurantWaitlistTable(VENUEID)
    }).catch(err => {
      Swal.fire("Something wrong happened", "", "error")
    })
  })

	function sum_price_order(data){
    let sum_addons = 0;
    if(data && data.addons){
    _.forEach(data.addons,(item)=>{
      sum_addons += (item.addon_price * item.addon_quantity)
    })
   }
    return (sum_addons + data.retail_price) * data.quantity
  }

  $('body').on('click', '.collapse_rOrdersList_btn', function() {
    const orderClicking = $(this).data("order-id")
    if(listOrderOpened.includes(orderClicking)) {
      listOrderOpened.splice(listOrderOpened.indexOf(orderClicking), 1);
    } else {
      listOrderOpened.push(orderClicking)
    }
  })
  $('body').on('click', '.collapse_orderTiming_btn', function() {
    const orderClicking = $(this).data("order-id")
    if(listOrderTimeOpened.includes(orderClicking)) {
      listOrderTimeOpened.splice(listOrderTimeOpened.indexOf(orderClicking), 1);
    } else {
      listOrderTimeOpened.push(orderClicking)
    }
  })
  function renderOrdersList(orders, orderId_render = false, updateAll){
    /*==COMMENTED FOR RESTAURANT ORDERS ARE NOT UPDATED IN REAL TIME==*/
    //const isSameOldOrders = listOrders && listOrders.length === orders.length && listOrders.every(function(value, index) { return value.orderId === orders[index].orderId});

    // if(isSameOldOrders && !isChangedDate && !isChangeOrderStatus){
    //   return;
    // } else {
    //   isChangeOrderStatus = false;
    //   listOrders = orders;
    // }

    let $orderListContainer = $("#restaurant-orders-container");
    if(updateAll) $orderListContainer.html('');
    let user_id = $('#userId').val().trim();
    if (orders && orders.length > 0) {
      orders.forEach((order, index) => {
      // Empty container
      let userCartOrder     = order.userCartOrder;
      // if(!(_.toLower(userCartOrder.orderExpectedTime) == "asap") && !isChangedDate){
      //   return ""
      // }
      let userCartItems     = userCartOrder.userCartItems;
      let orderChildren     = order.orderChildren;

      let joinedItemList = ``;
      let _joIndex = 0;

      let ORDER_ITEM_LISTS = [];
      orderChildren.forEach((items) =>{
        let isNoNapkins = items.noNapkinsPlasticware === false ? `<i class="fa fa-lg fa-square-o"></i>` : `<i class="fa fa-lg fa-check-square-o"></i>`
        const showNoNapkins = (items.orderType == 'delivery' || items.orderType == 'pickup') ? `
         <p>
          ${isNoNapkins} No Napkins/Plasticware.
         </p>

        ` : ``
        let statusPaid = `<span class="badge" style="background-color: gray; color: white;">unpaid</span>`
        if(items && items.isPaid && items.unPaid) {
          statusPaid = `<span class="badge" style="background-color: orange; color: white;">partially paid</span>`
        } else if(items && items.isPaid && !items.unPaid) {
          statusPaid = `<span class="badge" style="background-color: mediumseagreen; color: white;">paid</span>`
        }
        // GENERATE EACH USERS ACCORDIONs
        joinedItemList += `<div class="form-check position-rel">
                                <a href="#collapse_joined_rOrder_${index +'_'+_joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                    <span>${items.user} - Total: $${items.totalPrice && items.totalPrice >0 ? items.totalPrice : '0'}</span>
                                    ${statusPaid}
                                </a>
                                <div id="collapse_joined_rOrder_${index +'_'+_joIndex}" class="collapse show"  style="margin-left: 30px; margin-top: 10px;">`
                        let num_ratings = _.size(items.rating.list_rating);
                        let rating_mine = _.find(items.rating.list_rating, function(ele) {
                            return ele.posted_by == user_id;
                        });
                        var taxandfees=0;
                        taxandfees=parseFloat(items.taxAmount ? items.taxAmount :0) + parseFloat(items.convenience_fee_value ? items.convenience_fee_value :0)
                        if(typeof taxandfees !='undefined'){
                          taxandfees = taxandfees.toFixed(2);
                        }
                        rating_mine !== undefined ? rating_mine = rating_mine.rating : rating_mine = -1;
                              joinedItemList +=  `
                                                  <div class="customer-phone" style="padding-bottom:5px;">
                                                    <i class="fa fa-lg fa-phone-square" style="margin-right: 10px !important;"></i>
                                                    Customer phone number: <b>${ items.customerPhone || 'None'}</b>
                                                  </div>
                                                  <div class="customer-phone" style="padding-bottom:5px;">
                                                    <i class="fa fa-lg fa-envelope" style="margin-right: 10px !important;"></i>
                                                    Email: <b>${ items.customerEmail || ''}</b>
                                                  </div>
                                                  <div class="rate-customer-${items.userId} form-inline">
                                                  Customer Rating:&#160&#160
                                                  <div class="rating-customer-overal form-inline" style="margin-left: 0px !important;">
                                                      Overall&#160&#160
                                                      <input name="rateOveral" class="rate-customer-overall" data-id="overall-${items.orderId}" value="${items.rating.average_rating}"></input>
                                                  </div>
                                                  &#160&#160<span class="num-reviews" style="font-style: italic; font-size:15px;">${num_ratings} ${num_ratings > 1 ? 'reviews' : 'review'}</span>&#160&#160
                                                  <div class="rating-customer-mine form-inline" style="margin-left: 0px !important;">
                                                      &#160&#160My rating of this user (change anytime)&#160&#160
                                                      <input name="rateMine" class="rate-customer-mine" data-class="rate-customer-${items.userId}" data-id="mine-${items.orderId}" value="${rating_mine}" data-customerid="${items.userId}" data-permisstion="${rating_mine}"></input>
                                                  </div>
                                                </div>
                                ${renderComment(items, index, (_joIndex + '_orderJoin'))}
                                `
                                joinedItemList += `<div class="form-check position-rel mb-3">
                                    <a href="#collapse_dietary_${index +'_'+_joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                        <span>Food preferences</span>
                                    </a>
                                    <div id="collapse_dietary_${index +'_'+_joIndex}" class="collapse"  style="margin-left: 30px; margin-top: 10px;">
                                        <ul>
                                            <li>`;
                                              if (items.dietaryPreferences && items.dietaryPreferences.length >0) {
                                                items.dietaryPreferences.forEach((item) => {
                                                  joinedItemList += `<p><i class="fa fa-lg fa-check-square-o"></i> ${item.name} </p>`
                                                });
                                              }
                                              joinedItemList += `</li>

                                        </ul>
                                    </div>
                                </div>`;


                                joinedItemList += `<div class="form-check position-rel mb-3">
                                    <a href="#collapse_flavor_${index +'_'+_joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                        <span>Flavor preferences</span>
                                    </a>
                                    <div id="collapse_flavor_${index +'_'+_joIndex}" class="restaurant-order-info collapse"  style="margin-left: 30px; margin-top: 10px;">
                                        ${ renderSensoryProfile(items.tasterProfile) }
                                    </div>
                                </div>`;
                                joinedItemList += `
                                  <div>
                                    <fieldset id="instructionUserCartOrder-${items.orderId}-${items.userId}" class="fieldset fieldset-small" style="margin-bottom:10px; border: 2px solid mediumseagreen;">
                                      <legend align="left" style="font-size: 16px; font-weight: bold;">Order Special Instructions</legend>
                                      <span class="black" style="font-size: 14px;">${items.specialInstructions || ""}</span>
                                    </fieldset>
                                    ${showNoNapkins}
                                  </div>
                                `
                                joinedItemList += `<div class="form-check position-rel">
                                  <a href="#collapse_food_${index +'_'+_joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                      <span>Food Ordered</span>
                                  </a>
                                  <div id="collapse_food_${index +'_'+_joIndex}" class="collapse show"  style="margin-left: 30px; margin-top: 10px;">
                                  </div>
                                </div>`
                joinedItemList += `
                </div>
                  <div style="padding-left:100px;">
                    <div class="form-inline" style="width: 250px;">
                      <label style="width: 120px">Item Subtotal:</label>
                      <label style="float:right">$ ${parseFloat(items.taxable_subtotal).toFixed(2)}</label>
                    </div>
                    <div class="form-inline" style="width: 250px;">
                    <label style="width: 120px">Customer Convenience Fee:</label>
                    <label style="float:right">$ ${items.convenience_fee_value ? (parseFloat(items.convenience_fee_value)).toFixed(2) : '0.00'}</label>
                    </div>
                    <div class="form-inline" style="width: 250px;">
                    <label style="width: 120px">Taxes:</label>
                    <label style="float:right">$ ${(parseFloat(items.taxAmount)).toFixed(2) || '0.00'}</label>
                    </div>
                    ${userCartOrder.orderType == 'delivery' ?
                      `<div class="form-inline" style="width: 250px;">
                        <label style="width: 120px">Delivery fee:</label>
                        <label style="float:right">$ ${parseFloat(items.burq_delivery_fee && items.burq_delivery_fee>0 ? items.burq_delivery_fee : items.delivery_fee ).toFixed(2) }</label>
                      </div>`
                    : `` }
                    <div class="form-inline" style="width: 250px;">
                      <label style="width: 120px">Tip:</label>
                      <label style="float:right; ${items.tip_later == 'later' ? 'color: grey;' : ''}">$ ${items.tip_later == 'later' ? '(Later) ' : ''}${parseFloat(items.tip_amount + items.tip_platerate_free_food + items.tip_restaurant_free_food).toFixed(2)}</label>
                    </div>
                    <hr style="width: 250px;"/>
                    <div class="form-inline" style="width: 250px;">
                      <label style="width: 120px">Total:</label>
                      <label style="float:right">$ ${items && items.totalPrice> 0? parseFloat(items.totalPrice).toFixed(2) : '0.00'}</label>
                    </div>
                  </div>
              </div>`;


        // GENERATE ITEM LIST
        const $itemsList = $('<ul/>', {
          id: `cart-items-list-${index + '_' +_joIndex}`
        });
        if ( items.userCartItems && items.userCartItems.length ) {
          let list_items = items.userCartItems;
          list_items = _.orderBy(list_items,['updated_date'],['desc']);
          let paid_items = _.remove(list_items,(item)=>{
            return item.payment_id
          });
          list_items = _.concat(list_items,paid_items);
          list_items.forEach((item) => {
            let $itemLi = $("<li/>");
            const showSpecialInstruction = $('<a/>', {
              id: `instruction-${index + item.item_id}`,
              click: function() {
                $(`#instructionDiv-${index + item.item_id}`).toggle();
              }
            }).append(`<i class="fa fa-info-circle fa-lg ${(item.special_instructions) ? 'orange' : 'grey'}"></i>`);
            showSpecialInstruction.css( {'cursor'        : 'pointer',
                                          'margin-right' : '10px',
                                          'margin-left' : '10px'
                                        } );
            //Generate item details
            const itemExtendedPrice = item.extended_price.toFixed(2);
            let pathToItem = `
              <div class="row col-sm-12 col-md-12">
                  <p class="text-success">${item.menu_name} > ${item.section_name} ></p>
              </div>
            `;
            let paidItem =  item.payment_id ? `<span class="badge" style="background-color: mediumseagreen; color: white; font-size: 13px">paid</span>`: ''

            let $itemDetails = item.status != 'cancelled' ?
            $(`<div class="inline-flex-block cart-item-details">
                <label style="margin-top: 0px" id="itemorder-${item.cart_items_id}">
                  <input type="checkbox" class="restaurant-order-item selected-item" data-item="${item.cart_items_id}" data-order-id="${item.order_id}" style="display:none;">
                  <span class="label-text" style="font-size: 16px !important;">
                    <span class="item-name">${item.item_name}</span>(<span class="item-quantity">${item.quantity} order${item.quantity > 1 ? 's' : ''}</span>)
                    <span data-unit-price="${item.retail_price} "class="item-price">$${parseFloat(sum_price_order(item)).toFixed(2)}</span>
                    ${paidItem}
                  </span>
                </label>
              </div>`).append(showSpecialInstruction)
            :
            $(`<div class="inline-flex-block cart-item-details">
                  <label style="margin-top: 0px; text-decoration:line-through;" id="itemorder-${item.cart_items_id}">
                    <span class="label-text" style="font-size: 16px !important;">
                      <span class="item-name">${item.item_name}</span>(<span class="item-quantity">${item.quantity} order${item.quantity > 1 ? 's' : ''}</span>)
                      <span data-unit-price="${item.retail_price} "class="item-price">$${itemExtendedPrice}</span>
                      ${paidItem}
                    </span>
                  </label>
              </div>`).append(showSpecialInstruction)

            let $itemInstruction = $(`
              <br>
              <fieldset id="instructionDiv-${index + item.item_id}" class="fieldset fieldset-small" style="margin-bottom:10px;">
                <legend align="left">Menu Item Special Instructions</legend>
                <span class="black">${item.special_instructions || ""}</span>
              </fieldset>
            `);

            $itemLi.append(pathToItem).append($itemDetails).append(`<div style=" margin-left: 35px;">${renderAddon(item)}</div>`);
            $itemLi.append($itemInstruction);
            $itemsList.append($itemLi);

            ORDER_ITEM_LISTS.push({
              index : index + '_' +_joIndex,
              $itemList : $itemsList
            });
          });
        }
        _joIndex++;

      });


      // GENERATE ORDER DETAILS
      let order_status = {
        'pickup': [
          {key: 'acknowledged', label: 'Acknowledge', index: 0},
          {key: 'sent_to_kitchen', label: 'Sent to kitchen', index: 1},
          {key: 'ready_for_pickup', label: 'Ready for Pickup', index: 2},
          {key: 'customer_picked_up', label: 'Customer Picked Up', index: 3},
          {key: 'completed', label: 'Close Order', index: 4}
        ],
        'delivery': [
          {key: 'acknowledged', label: 'Acknowledge', index: 0},
          {key: 'sent_to_kitchen', label: 'Sent to kitchen', index: 1},
          {key: 'sent_for_delivery', label: 'Sent for Delivery', index: 2},
          {key: 'delivered', label: 'Delivered', index: 3},
          {key: 'completed', label: 'Close Order', index: 4}
        ],
        'order-ahead': [
          {key: 'acknowledged', label: 'Confirm Reservation', index: 0},
          {key: 'sent_to_kitchen', label: 'Sent to kitchen/bartender', index: 1},
          {key: 'ready_to_serve', label: 'Food/drink ready to serve', index: 2},
          {key: 'served', label: 'Served Food/Drink', index: 3},
          {key: 'ready_to_checkout', label: 'Conclude Bill', index: 4},
          {key: 'completed', label: 'Close Order', index: 5}
        ],
      }


      let current_order_status = order_status[userCartOrder.orderType]
      let currentStatus = ''
      let nextStatus = ''
      let changeStatusBtnName = ''

      if(!userCartOrder.orderStatus) {
        nextStatus = current_order_status[0].key
        changeStatusBtnName = current_order_status[0].label
      }else{
        let order_state = _.find(current_order_status, el => el.key == userCartOrder.orderStatus)
        currentStatus = order_state && order_state.label
        if(order_state && (order_state['index'] + 1 <  current_order_status.length)){
          nextStatus = current_order_status[order_state['index'] + 1].key
          changeStatusBtnName = current_order_status[order_state['index'] + 1].label
        }
      }

        let cliamOpiont = $('#servername-drop').html();
        let label_order_time = [];
        let order_name = ''

        if(userCartOrder.orderType == 'order-ahead'){
        label_order_time[0] = 'Reservation Requested';
        label_order_time[1] = 'Confirm Reservation';
        label_order_time[2] = 'Send order to kitchen';
        label_order_time[3] = 'Food/drink ready to serve';
        label_order_time[4] = 'Customer said they were in the restaurant';
        order_name = 'Dine In'
        }else if(userCartOrder.orderType == 'delivery'){
        label_order_time[0] = 'Order placed';
        label_order_time[1] = 'Acknowledged';
        label_order_time[2] = 'Delivering';
        label_order_time[3] = 'Delivered (per restaurant)';
        label_order_time[4] = 'Delivered (per customer)';
        order_name = 'Delivery'
        }else{
          label_order_time[0] = 'Order placed';
          label_order_time[1] = 'Acknowledged';
          label_order_time[2] = 'Ready for Pickup';
          label_order_time[3] = 'Picked up (per restaurant)';
          label_order_time[4] = 'Picked up (per customer)';
          order_name = 'Pickup'
        }
        let day_remaining;
        if(userCartOrder.orderType == "order-ahead"){
        let time_begin = moment(userCartOrder.orderExpectedTime).format('MM/DD/YYYY hh:mm:a');
        let time_reserve = moment(time_begin).add(-userCartOrder.invitesDay, 'days');
        day_remaining = _.round(time_reserve.diff(moment(), 'hours')/24,2);
        if(day_remaining < 0) day_remaining = 0;
      }
      let expected_datetime;
      if(_.toLower(userCartOrder.orderExpectedTime) == "asap"){
        expected_datetime = "ASAP";
      }else{
        console.log("Checking venueTimezone==========",userCartOrder.venueTimezone)
        let check_time = moment(userCartOrder.orderExpectedTime).isValid();
        if(check_time){
          expected_datetime = moment(userCartOrder.orderExpectedTime).tz(userCartOrder.venueTimezone).add(userCartOrder.deliveryMinTime, 'minutes').format('MM/DD/YYYY hh:mm a');
        }else{
          expected_datetime = moment(userCartOrder.placedDate).format('MM/DD/YYYY hh:mm a');
        }
      }

        let addClassShow = false;
        let addClassShowTime = false;
        if(listOrderOpened.includes(userCartOrder.orderId)) {
          addClassShow = true;
        }
        if(listOrderTimeOpened.includes(userCartOrder.orderId)) {
          addClassShowTime = true;
        }
        let orderHTML = `<div class="form-check position-rel restaurant-order-tree accord-box" id="item-list-order-${userCartOrder.orderId}" data-index="${index}" style="margin-bottom:1rem;margin-top:1rem;">
                              <a href="#collapse_rOrdersList_${index}" data-toggle="collapse" data-order-id="${userCartOrder.orderId}" ${addClassShow ? 'aria-expanded ="true"' : ""} class="collapse_rOrdersList_btn title-handle ${(show == userCartOrder.orderId && updateAll) || addClassShow ? '' : 'collapsed'}">
                                  <span class="order-name gg">${(userCartOrder.orderName) ? userCartOrder.orderName.replace('Order', `${order_name} Order`) : 'My Order'}</span>
                                  ${(userCartOrder.paidStatus == "unpaid") ?
                                    `<span class="badge" style="background-color: gray; color: white;">
                                        unpaid
                                    </span>` : ``
                                  }
                                  ${(userCartOrder.paidStatus == "partially-paid") ?
                                    `<span class="badge" style="background-color: orange; color: white;">
                                        partially paid
                                    </span>` : ``
                                  }
                                  ${(userCartOrder.paidStatus == "paid") ?
                                    `<span class="badge" style="background-color: mediumseagreen; color: white;">
                                        paid
                                    </span>` : ``
                                  }
                                  <span style="font-size: 1.7rem;"> - ${currentStatus=='Acknowledge'? 'Acknowledged': currentStatus}</span>
                                  <span style="font-size: 1.7rem;"> ${(userCartOrder.totalOfAll && userCartOrder.totalOfAll>0 ) ? ` ($${userCartOrder.totalOfAll})` : '($0)'}</span>
                                  ${(changeStatusBtnName && !userCartOrder.declinedOrder) ?
                                    `<a class="btn btn-warning change-order-status-btn" style="text-transform:capitalize;color:black;margin-left:20px;margin-bottom: 5px;"
                                        data-order-id="${userCartOrder.orderId}" data-value="${nextStatus}" data-order-type="${userCartOrder.orderType}">
                                        ${changeStatusBtnName}
                                    </a>`
                                    : ''}
                                  ${changeStatusBtnName == 'Confirm Reservation' && !userCartOrder.declinedOrder ?
                                    `<a class="btn btn-danger decline-reservation-btn" style="text-transform:capitalize;color:black;margin-left:20px;margin-bottom: 5px;"
                                        data-order-id="${userCartOrder.orderId}">
                                        Decline Reservation
                                    </a>`
                                    : ''
                                  }
                                  ${
                                    userCartOrder.declinedOrder ? (
                                      `<label style="color: red">Declined</label>`
                                    ) : ''
                                  }
                              </a>
                              <div id="collapse_rOrdersList_${index}" class="collapse ${addClassShow ? " show " : ""} ${(orderId_render == userCartOrder.orderId  && updateAll) || addClassShow ? 'in show" aria-expanded ="true"' : '"'} style="margin-left: 30px; margin-top: 10px;">
                                  <div class="form-check position-rel">

                                  <div>
                                    <b>Order number# ${userCartOrder.orderId} </b>
                                    <input type="hidden" id="isDeliverectOrder" value="${userCartOrder.deliverectChannelLinkid? true: false}">
                                  </div>
                                  ${(userCartOrder.orderType == 'delivery' || userCartOrder.orderType == 'pickup') && userCartOrder.delivery_contactless != '' && userCartOrder.delivery_contactless != null ?
                                    `<div class="mb-3">
                                    <a href="#collapse_contactless_delivery_${userCartOrder.orderId}" data-toggle="collapse" class="title-handle" aria-expanded="true" style="color: red;">
                                      <span>Contactless ${userCartOrder.orderType == 'delivery' ? "delivery" : "pickup"}</span>
                                    </a>
                                    <div id="collapse_contactless_delivery_${userCartOrder.orderId}" class="collapse in show" style="margin-left: 30px; margin-top: 10px;" aria-expanded="true">
                                      <div class="row">
                                          <label class="col-xs-6 col-sm-6 col-md-6">Contactless ${userCartOrder.orderType == 'delivery' ? "delivery" : "pickup"} : ${userCartOrder.delivery_contactless == 'contactless' ? 'Yes' : 'No'}</label>                                      </div>
                                      <div class="row">
                                          <label class="col-xs-6 col-sm-6 col-md-6">Describe: ${userCartOrder.delivery_contactless == 'contactless' ? userCartOrder.delivery_contactless_note : ''}</label>
                                      </div>
                                    </div>
                                  </div>
                                    ` : ``}
                                  ${userCartOrder.orderType == 'order-ahead' ?
                                    `
                                    <div class="mb-3">
                                      <div id="collapse_ahead_info_${userCartOrder.orderId}">
                                        <div class="row">
                                            <label class="col-xs-6 col-sm-6 col-md-3">Total # of Reservation:</label>
                                            <label class="col-xs-6 col-sm-6 col-md-9">${userCartOrder.reserveSpace || 0}</label>
                                        </div>
                                        <div class="row">
                                            <label class="col-xs-6 col-sm-6 col-md-3"># Reserved:</label>
                                            <label class="col-xs-6 col-sm-6 col-md-9">${_.size(userCartOrder.orderChildren)}</label>
                                        </div>
                                        <div class="row">
                                            <label class="col-xs-6 col-sm-6 col-md-3">Reservation Date/Time:</label>
                                            <label class="col-xs-4 col-sm-4 col-md-3">
                                              <input type="text" class="form-control reservation-time" data-order-id="${userCartOrder.orderId}" id="reservation-time-${userCartOrder.orderId}" data-value="${userCartOrder.orderExpectedDate.indexOf('asap') == -1 ? moment(userCartOrder.orderExpectedDate).toDate() : "null"}"/>
                                            </label>
                                            <a href="javascript:0" class="btn btn-success form-control save-reservation-time col-12 col-md-3" data-order-id="${userCartOrder.orderId}" style="color: white;width: 20px; margin-top: 8px;">Save and Notify customer</a>

                                        </div>
                                        <div class="row">
                                            <label class="col-xs-6 col-sm-6 col-md-3">Reservation Length:</label>
                                            <label class="col-xs-6 col-sm-6 col-md-9">${userCartOrder.reservationHours} hour(s) ${userCartOrder.reservationMinutes} minutes</label>
                                        </div>
                                        <div class="row">
                                            <label class="col-xs-6 col-sm-6 col-md-3">Days Remaining For people to reserve:</label>
                                            <label class="col-xs-6 col-sm-6 col-md-9">${day_remaining || 0}</label>
                                        </div>
                                      </div>
                                    </div>
                                    `
                                  : ''}
								  <div class="mb-3">
									  </div>
                                      <div id="collapse_order_type_${index + _joIndex}" class=""  style="margin-top: 10px;">
                                              ${(userCartOrder.orderType == "delivery" || userCartOrder.orderType == "pickup") ?
                                                `<div class="edit-assign ${userCartOrder.serverId ? 'hidden': ''}"><i class="fa fa-lg fa-square-o"></i> ${userCartOrder.orderType == "delivery" ? "Delivery" : "Pickup"} Person :
                                                      <button type="button" class="btn btn-sm btn-assign-order"
                                                        data-order-id="${userCartOrder.orderId}"
                                                        data-order-address="${userCartOrder.deliveryAddress}"
                                                        data-table-name="${userCartOrder.orderName}">Claim this order</button>
                                                      <p style="display: inline-block;">Assign to:</p>
                                                      <select class="form-control cliam_person" data-order-id="${userCartOrder.orderId}" data-order-address="${userCartOrder.deliveryAddress}" data-table-name="${userCartOrder.orderName}" style="width: auto;display: inline-flex;">
                                                      ${cliamOpiont}
                                                      </select>
                                                      ${userCartOrder.serverId
                                                        ? `<button type="button" class="btn btn-sm btn-cancel-assign">Cancel</button>`
                                                        : ''
                                                      }
                                                    </div>
                                                    <div class="show-assign ${userCartOrder.serverId ? '': 'hidden'}">
                                                      <p><i class="fa fa-lg fa-check-square-o"></i> ${userCartOrder.orderType == "delivery" ? "Delivery" : "Pickup"} Person : ${userCartOrder.serverName} <button type="button" class="btn btn-xs btn-change-assign" data-assign-id="${userCartOrder.serverId}">Change</button></p>
                                                    </div>`
                                                : ''
                                              }
                                              ${(userCartOrder.orderType == "order-ahead") ?
                                                `<div class="edit-assign ${userCartOrder.serverId ? 'hidden': ''}"><i class="fa fa-lg fa-square-o"></i> Waitstaff:
                                                      <button type="button" class="btn btn-sm btn-assign-order"
                                                        data-order-id="${userCartOrder.orderId}"
                                                        data-order-address="${userCartOrder.deliveryAddress}"
                                                        data-order-type="${userCartOrder.orderType}"
                                                        data-table-name="${userCartOrder.orderName}">Claim this order</button>
                                                      <p style="display: inline-block;">Assign to:</p>
                                                      <select class="form-control cliam_person" data-order-id="${userCartOrder.orderId}" data-order-address="${userCartOrder.deliveryAddress}" data-order-type="${userCartOrder.orderType}" data-table-name="${userCartOrder.orderName}" data-server-id="${userCartOrder.server_id}" style="width: auto;display: inline-flex;">
                                                      </select>
                                                      ${userCartOrder.serverId
                                                        ? `<button type="button" class="btn btn-sm btn-cancel-assign">Cancel</button>`
                                                        : ''
                                                      }
                                                    </div>
                                                    <div class="show-assign ${userCartOrder.serverId ? '': 'hidden'}">
                                                      <p><i class="fa fa-lg fa-check-square-o"></i> Waitstaff: ${userCartOrder.serverName} <button type="button" class="btn btn-xs btn-change-assign" data-assign-id="${userCartOrder.serverId}">Change</button></p>
                                                    </div>`
                                                : ''
                                              }
                                      </div>
                                  </div>

                                  <div class="form-check position-rel mb-3">
                                      <a href="#collapse_order_timing_${index + _joIndex}" data-toggle="collapse" data-order-id="${userCartOrder.orderId}" ${addClassShowTime ? 'aria-expanded ="true"' : ""} class="collapse_orderTiming_btn title-handle ${(show == userCartOrder.orderId && updateAll) || addClassShowTime ? '' : 'collapsed'}">
                                          <span>Order Timing</span>
                                      </a>
                                      <div id="collapse_order_timing_${index + _joIndex}"  class="collapse ${addClassShowTime ? " show " : ""} ${(orderId_render == userCartOrder.orderId  && updateAll) || addClassShowTime ? 'in show" aria-expanded ="true"' : '"'}  style="margin-left: 30px; margin-top: 10px;">
                                          <ul>
                                            <li>
                                              ${(userCartOrder.placedDate) ?
                                                `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[0]}: ${new Date(userCartOrder.placedDate).toLocaleString()}</p>`
                                                :
                                                `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[0]}</p>`
                                              }
                                              ${(userCartOrder.acknowledgedDate) ?
                                                `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[1]}: ${moment(moment.utc(userCartOrder.acknowledgedDate).toDate()).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                :
                                                `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[1]}</p>`
                                              }
                                              ${userCartOrder.orderType == 'order-ahead' ?
                                                userCartOrder.arrivedDate ?
                                                  `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[4]}: ${moment(moment.utc(userCartOrder.arrivedDate).toDate()).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                  :
                                                  `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[4]}</p>`
                                                : ''}
                                              ${userCartOrder.orderType == 'delivery' ?
                                                userCartOrder.deliveringDate ?
                                                `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[2]}: ${moment(moment.utc(userCartOrder.deliveringDate).toDate()).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                :
                                                `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[2]}</p>`
                                                : userCartOrder.orderType == 'pickup' ?
                                                userCartOrder.ready_for_pickup ?
                                                `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[2]}: ${moment(moment.utc(userCartOrder.ready_for_pickup).toDate()).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                :
                                                `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[2]}</p>`
                                                : ''
                                              }
                                              ${(userCartOrder.deliveredPerRestaurantDate) ?
                                                `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[3]}: ${moment(moment.utc(userCartOrder.deliveredPerRestaurantDate).toDate()).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                :
                                                `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[3]}</p>`
                                              }
                                              ${userCartOrder.orderType != 'order-ahead' ?
                                                userCartOrder.deliveredPerCustomerDate ?
                                                  `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[4]}: ${moment(moment.utc(userCartOrder.deliveredPerCustomerDate).toDate()).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                  :
                                                  `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[4]}</p>`
                                                :''
                                              }
                                            </li>
                                          </ul>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          `;
        if(!updateAll && orderId_render == userCartOrder.orderId){
          $orderListContainer.find(`#item-list-order-${userCartOrder.orderId}`).replaceWith(orderHTML);
        }else if(updateAll) {
          $orderListContainer.append(orderHTML);
        }
        // $(`#reservation-time-${userCartOrder.orderId}`).datetimepicker({
        //   showClose: true,
        //   icons: {
        //     close: 'closeText'
        //   },
        //   defaultDate: userCartOrder.orderExpectedDate.indexOf('asap') == -1 ? moment(userCartOrder.orderExpectedDate).format('MM/DD/YYYY') : ""
        // });

        let infoHTML = `<hr>
													${userCartOrder.orderType && userCartOrder.orderType != 'pickup' ?
															`<fieldset class="fieldset fieldset-medium">
															<legend align="left">Delivery Address</legend>
															${userCartOrder.orderType && userCartOrder.orderType != '' ?
																`<span class="black" style="font-size:17px;">
																	This is a ${userCartOrder.orderType == 'order-ahead' ? 'Dine-in' : userCartOrder.orderType.charAt(0).toUpperCase() + userCartOrder.orderType.slice(1)} order
																</span></br>`
															: ``
															}
															<span class="black" style="font-size:17px;">${userCartOrder.deliveryAddress || ''}</span>
														  <p class="black" style="font-size:17px;">${userCartOrder.apartmentAddress || ''}</p>

                            </fieldset>`
													: `<span class="black" style="font-size:17px;">
																This is a ${userCartOrder.orderType == 'order-ahead' ? 'Dine-in' : userCartOrder.orderType.charAt(0).toUpperCase() + userCartOrder.orderType.slice(1)} order
															</span></br>`
													}

                        <label>When would you like this order</label>
                        <div>
                          <label class="btn btn-default label-box">
                            ${expected_datetime? expected_datetime.toLocaleString(): expected_datetime}
                          </label>
                        </div>
                        ${userCartOrder.orderType == 'delivery' ? alcohol_devirery(order): ''}
                        ${(userCartOrder.specialInstructions) ?
                          `<fieldset class="fieldset fieldset-medium">
                            <legend align="left">Order Special Instructions</legend>
                            <span class="black" style="font-size:17px;">
                              ${userCartOrder.specialInstructions}
                            </span>
                          </fieldset>`
                          : ''}
                        <div class="row" style="margin-top: 30px;">
                          <div class="col-md-6" style="margin: 0 auto; float:none;">
                              <div class="col-md-12 mb-3"  style="margin-top:20px;">
                                <button type="button" disabled class="btn btn-lg btn-block cancel-selected-item" data-order-id="${userCartOrder.orderId}" data-order-index="${index}">Cancel Selected Items</button>
                              </div>
                          </div>
                        </div>
                        `;

        let $orderList = $(`#collapse_rOrdersList_${index}`);

        $orderList.append(joinedItemList);
        ORDER_ITEM_LISTS.forEach(list => {
          $(`#collapse_joined_rOrder_${list.index}`).find(`#collapse_food_${list.index}`).append(list.$itemList)
        })
        $orderList.append(infoHTML);
        $(`#collapse_rOrdersList_${index} .range-slider`).bootstrapSlider({
            min: 0,
            max: 100,
            range: true,
            enabled: false,
            values: [40, 60]
        });
      });
    } else { $orderListContainer.append(`<p class="grey">There are no orders.</p>`); }
    render_rating_customer('#restaurant-orders-container');

    $.each($(".reservation-time"), function(index, elem){
      if(elem!=='NaN'){
        let val = $(elem).data('value')
        $(elem).datetimepicker({
          format:'MM/DD/YYYY LT',
          defaultDate: moment(val).format('MM/DD/YYYY hh:mm A'),
        })
      }

    })
    $('.save-reservation-time').on('click', function(e){
      let $this = $(this);
      let data = {
        orderId : $this.data("order-id"),
        timeReservation : $this.parent().find('.reservation-time').val()
      }
      $.ajax({
        url: '/orders/editReservationTime',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function(data) {
          if(data.type == 'error'){
            $this.parent().find('.reservation-time').val("");
          }
          Swal.fire(data.message, '', data.type);

        }
      });
    })

    //
    $('.upload-photo-id').on('click', function(e) {
      e.preventDefault();
      window.$amazon.multiple = false;
      window.$amazon.type = 'photo_id';
      window.$amazon.frame = 3/2;
      window.$amazon.data = {
        side: $(this).data('side'),
        order_id: $(this).data('order-id')
      }
      $(window.$amazon.input).click();
    })

    $('.drop-off-alcohol').on('click', function(e){
      e.preventDefault();
      let data = {
        drop_off: $(this).data('drop-off') == 'yes',
        order_id: $(this).data('order-id')
      }
      $.ajax({
        url: '/orders/delivery-photo-id',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data),
        success: function(res) {
          return toastr.success('Delivery Completed')
        },
        error: function(err){
          if(err.responseJSON.data == 'required-photoID') return toastr.warning("Can't complete. You need to get enough photo ID")
          return toastr.error('Error. Please try again')
        }
      })
    })
   
    //
     // var arrSelectedItem = []
 $('#restaurant-orders-container').on('change', '.restaurant-order-item', function(){
  let $container = $(this).parents('.restaurant-order-tree');
  let itemlist   = $container.find('input.restaurant-order-item:checked');
  let btncancel  = $container.find('.cancel-selected-item');
  if(itemlist && itemlist.length > 0) {
    btncancel.attr('disabled', false);
  } else {
    btncancel.attr('disabled', true);
  }
 })

 $('#restaurant-orders-container').on('click', '.cancel-selected-item', function(){
    let $container = $(this).parents('.restaurant-order-tree');
    let itemlist   = $container.find('input.restaurant-order-item:checked');
    let orderitemlist   = $container.find('input.restaurant-order-item');
    let btncancel  = $container.find('.cancel-selected-item');
    let isDeliverectOrder  = $container.find('#isDeliverectOrder').val();
    let deliverectFlag = false;
    if(orderitemlist.length === itemlist.length && isDeliverectOrder==='true'){
      deliverectFlag = true;
    }
    
    let arrSelectedItem = [];
    let orderId = $(this).data('order-id');
    let order_index = $(this).data('order-index');

    if(itemlist && itemlist.length > 0) {
      $.each(itemlist, function(name, item){
          let item_id = $(item).data('item')
          let order_id = $(item).data('order-id')
          arrSelectedItem.push({item_id, order_id})
      })
    }

   if(arrSelectedItem && arrSelectedItem.length){
    let venueId = VENUEID;
    function swalCancelItem() {
      Swal.fire({
        title: `You want to cancel the selected items`,
        text: 'Cancelling this order will refund the customer, are you sure you want to do that?',
        icon: "warning",
        showCancelButton: true,  // Allow cancel option
        confirmButtonText: "Yes, cancel it!", // Confirm button text
        cancelButtonText: "No, keep it",
        allowOutsideClick: true  // Prevent closing without interaction
      }).then((result) => {
      if (result.isConfirmed) {
        cancelItemOrder({
          venueId: VENUEID,
          arrItemId: arrSelectedItem,
          list_index: order_index,
          fullyCancel: deliverectFlag
        });
      }
    });
    }
    
    swalExtend.call(this, {
      swalFunction: swalCancelItem,
      hasCancelButton: true,
      buttonNum: 2,
      buttonColor: ["#b30000", "#3CB371"],
      buttonNames: ["No","Yes"],
      clickFunctionList: [
        function() {
          return false;
        },
        function() {
          cancelItemOrder({venueId: venueId, arrItemId: arrSelectedItem, list_index: order_index, fullyCancel: deliverectFlag});
          return true;
        },
      ]
    });
   }
  })
  $('#restaurant-orders-container').on('click', '.btn-change-assign', function(){
    let assignId = $(this).data('assign-id');
    $('#restaurant-orders-container').find('.edit-assign').removeClass('hidden');
    $('#restaurant-orders-container').find('.show-assign').addClass('hidden');
    if(assignId !== USER_ID) {
      $('#restaurant-orders-container').find('.cliam_person').val(assignId);
      getRestaurantOrders();
    }
  })
  $('#restaurant-orders-container').on('click', '.btn-cancel-assign', function(){
    $('#restaurant-orders-container').find('.edit-assign').addClass('hidden');
    $('#restaurant-orders-container').find('.show-assign').removeClass('hidden');
    getRestaurantOrders();
  })
}

window.$amazon.callback['photo_id'] = function(){
  let data = {
      image: window.$amazon.urls[0],
      ...window.$amazon.data
  }
  $.ajax({
      url: '/orders/delivery-photo-id',
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data),
  })
  .then((res)=> {
      update_delivery_photo_id(data);
  })
};
function update_delivery_photo_id(data){
  if(!data) return false;
  let element = $(`#delivery-photo-id-for-${data.order_id}`)
  element.find(`.${data.side}-photo-id`).attr("src", data.image);
}



var alcohol_devirery = (order)=>{
  let alcohol = false
  _.forEach(order.orderChildren, elem =>{
    _.forEach(elem.userCartItems, item =>{
      if (item.alcohol) {
        alcohol = true
        return false
      }
    })
    return !alcohol
  })
  if(!alcohol) return ''
  let order_infor = order.userCartOrder
  let order_id = order_infor.orderId
  let html = `
    <div id="delivery-photo-id-for-${order_id}">
      <div class="h4">This Delivery Includes Alcohol, You Must Attach Photo ID</div>
      <div class="row">
        <div class="col-sm-12 col-md-4 text-center">
          <div class="h5">Front</div>
          <div>
            <img class="front-photo-id" src="${order_infor.delivery_front_photoID || '/images/avatar.png'}" style="height: 200px">
          </div>
          <a href="javascript:void(0)" class="upload-photo-id" data-side="front" data-order-id="${order_id}">Upload Photo</a>
        </div>
        <div class="col-sm-12 col-md-4 text-center">
          <div class="h5">Back</div>
          <div>
            <img class="back-photo-id" src="${order_infor.delivery_back_photoID || '/images/avatar.png'}" style="height: 200px">
          </div>
          <a href="javascript:void(0)" class="upload-photo-id" data-side="back" data-order-id="${order_id}">Upload Photo</a>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12 col-md-6">
          ${order_infor.delivery_drop_off === 1 ?
            `
            <div class="alert alert-success" role="alert">
              Delivery completed
            </div>
            ` : order_infor.delivery_drop_off === 0 ?
            `
            <div class="alert alert-warning" role="alert">
              Delivery done but didn't drop off alcohol
            </div>
            `: ''
          }
          <div class="d-flex justify-content-between">
            <button class="btn btn-success drop-off-alcohol" data-order-id="${order_id}" data-drop-off="yes">Delivery Done</button>
            <button class="btn btn-warning drop-off-alcohol" data-order-id="${order_id}" data-drop-off="no">No ID - Didn’t drop off alcohol</button>
          </div>
        </div>
      </div>
    </div>
  `;
  return html

}
//  Render addons
 const renderAddon = (item) => {
  let htmlAddon = '';
  let menuItem = null;
  let dataTree = $('#tree-data').length && $('#tree-data').val() ? JSON.parse($('#tree-data').val()) : [];
  menuItem = getMenuItem(dataTree, item.item_id);
  if(menuItem && menuItem.children && item.addons && item.addons.length) {
    htmlAddon = renderOrderItemAddons(menuItem.children, item)
  }
  return htmlAddon;
}

const getMenuItem = (menus, key) => {
  let menuFound = null;
  if(menus && menus.length) {
    menus.forEach((menu) => {
      if(menuFound) {
        return menuFound
      } else if(menu && menu.type == 'item' && menu.key === key) {
        menuFound = menu;
      } else if(menu && menu.children && menu.children.length && menu.type != 'item') {
        menuFound = getMenuItem(menu.children, key);
      }
    })
  }
  return menuFound;
}

const renderForEchAddons = (menuAddons, item) => {
  let htmlAddon = '';
  const addons =  item.addons
  if(menuAddons && menuAddons.length) {
    menuAddons.forEach((addon) => {
      if(addon && addon.children) {
        let htmlChild = renderForEchAddons(addon.children, item)
        if(htmlChild) {
          htmlAddon += `<div><p style="margin: 0px; font-size: 14px;">${ addon.title }</p> ${ htmlChild }</div>`
        }
      } else {
        let cartAddon = addons.find((i)=> i.item_id == addon.key);
        let addon_quantity = 0;
        let addon_extended_price = 0;
        let addon_price = addon.data && addon.data.price ? addon.data.price : 0;
        if(cartAddon && cartAddon.addon_quantity) {
          addon_quantity = cartAddon.addon_quantity;
          addon_extended_price = cartAddon.addon_extended_price;

          let total_quantity = cartAddon.addon_quantity * (item.quantity || 1);
          let total_price = cartAddon.addon_extended_price * (item.quantity || 1);

          htmlAddon +=  `<div style="margin-left: 20px;">
                          <div class="hidden" id="addon-${addon.key}">
                            <input type="hidden" class="quantity" value="${addon_quantity}">
                          </div>
                          <small>${addon.title} ${total_quantity} x $${addon_price} = $${total_price}</small>
                        </div>`
        }
      }
    })
  }
  return htmlAddon;
}

const renderOrderItemAddons = (menuAddons, item) => {
  let htmlAddon = '';
  const addons =  item.addons
  if(menuAddons && menuAddons.length) {
    menuAddons.forEach((addon) => {
      if(addon && addon.children && addon.children.length) {
        let htmlChild = renderOrderItemAddons(addon.children, item)
        if(htmlChild) {
          htmlAddon += `<div><p style="margin: 0px; font-size: 14px;">${ addon.title }</p> ${ htmlChild }</div>`
        }

      } else {
        let cartAddon = addons.find((i)=> i.item_id == addon.key);
        let addon_quantity = 0;
        let addon_extended_price = 0;
        let addon_price = addon.price ? addon.price : 0;
        if(cartAddon && cartAddon.addon_quantity) {
          addon_quantity = cartAddon.addon_quantity;
          addon_extended_price = cartAddon.addon_extended_price;

          let total_quantity = cartAddon.addon_quantity * (item.quantity || 1);
          let total_price = parseFloat(cartAddon.addon_extended_price * (item.quantity || 1)).toFixed(2)

          htmlAddon +=  `<div style="margin-left: 20px;">
                          <div class="hidden" id="addon-${addon.key}">
                            <input type="hidden" class="quantity" value="${addon_quantity}">
                          </div>
                          <small>${addon.title} ${total_quantity} x $${addon_price} = $${total_price}</small>
                        </div>`
        }
      }
    })
  }
  return htmlAddon;
}

 function cancelItemOrder(data) {
   let list_index = data.list_index;
   let cancel_button = $(`#collapse_rOrdersList_${list_index}`).find('.cancel-selected-item');
   cancel_button.text('Processing...');
   cancel_button.attr('disabled', true);
   delete data.list_index;
  if(data && data.arrItemId && data.arrItemId.length) {
    $.ajax({
      url: '/orders/cancelItemsOrder',
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      dataType: 'json',
      error: function(err) {
        const errorMessage = err && err.responseJSON && err.responseJSON.details
        Swal.fire('Unable to cancel selected items', errorMessage || 'Please Try Again!', 'error');
        cancel_button.text('Cancel Selected Items');
        $('#restaurant-orders-container').find('.cancel-selected-item').attr('disabled', false);
      },
      success: function(res) {
        getRestaurantOrders().then((success)=>{
          $(`#collapse_rOrdersList_${list_index}`).collapse("show");
        });
        // data.arrItemId.forEach(function(item) {
        //     $('#restaurant-orders-container').find(`#itemorder-${item}`).find('input').remove();
        //     $('#restaurant-orders-container').find(`#itemorder-${item}`).css('text-decoration', 'line-through');
        // })
        cancel_button.text('Cancel Selected Items');
        $('#restaurant-orders-container').find('.cancel-selected-item').attr('disabled', false);
        Swal.fire('Cancel selected items successful', '', 'success');
      }
    })
  }
 }

 $('#icon_closed_order_date').click(function(){
    $('#closed-order-date').trigger('focus')
  })
 

 if(window.location.href.includes('RestaurantOrder')){
  getRestaurantOrders();
  getRestaurantClosedOrders();
 }else{
  $('#headingRestaurantOrder').on('click',function(){
    $(this).unbind('click');
    getRestaurantOrders();
     getRestaurantClosedOrders();
  })
}

 if(window.location.href.includes('RestaurantOrder')){
  let _date = new Date();
  getRestaurantClosedOrders();
 }else{
  $('#headingRestaurantOrder').on('click',function(){
    $(this).unbind('click');
    getRestaurantOrders();
    getRestaurantClosedOrders();
  })
}


 // Render closed order list by date
  function renderClosedOrdersList(orders){
   
    let $orderListContainer = $("#restaurant-closed-orders-container");
    $orderListContainer.empty();
    let user_id = $('#userId').val().trim();
    if (orders && orders.length > 0) {
      orders.forEach((order, index) => {
        // Empty container
        let userCartOrder     = order.userCartOrder;
        let userCartItems     = userCartOrder.userCartItems;
        let orderChildren  = order.orderChildren;

        let joinedItemList = ``;
        let _joIndex = 0;

        orderChildren.forEach((items) =>{
          joinedItemList += `<div class="form-check position-rel">
                                <a href="#collapse_joined_rClosedOrder_${index +'_'+ _joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                    <span>${items.user}</span>
                                </a>
                                <div id="collapse_joined_rClosedOrder_${index +'_'+_joIndex}" class="collapse"  style="margin-left: 30px; margin-top: 10px;">`
              let num_ratings = _.size(items.rating.list_rating);
              let rating_mine = _.find(items.rating.list_rating, function(ele) {
                  return ele.posted_by == user_id;
              });
              rating_mine !== undefined ? rating_mine = rating_mine.rating : rating_mine = -1;
              joinedItemList +=  `
                                    <div class="customer-phone" style="padding-bottom:5px;">
                                      <i class="fa fa-lg fa-phone-square" style="margin-right: 10px !important;"></i>
                                      Customer phone number: <b>${ items.customerPhone || 'None'}</b>
                                    </div>
                                    <div class="customer-phone" style="padding-bottom:5px;">
                                      <i class="fa fa-lg fa-envelope" style="margin-right: 10px !important;"></i>
                                      Email: <b>${ items.customerEmail || ''}</b>
                                    </div>
                                    <div class="rate-customer-${items.userId}">
                                    Customer Rating":&#160&#160
                                    <div class="rating-customer-overal inline-flex-block" style="margin-left: 0px !important;">
                                        Overall&#160&#160
                                        <input name="rateOveral" class="rate-customer-overall" data-id="overall-${items.orderId}" value="${items.rating.average_rating}"></input>
                                    </div>
                                    &#160&#160<span class="num-reviews" style="font-style: italic; font-size:15px;">${num_ratings} ${num_ratings > 1 ? 'reviews' : 'review'}</span>&#160&#160
                                    <div class="rating-customer-mine inline-flex-block" style="margin-left: 0px !important;">
                                        &#160&#160My rating of this user (change anytime)&#160&#160
                                        <input name="rateMine" class="rate-customer-mine" data-class="rate-customer-${items.userId}" data-id="mine-${items.orderId}" value="${rating_mine}" data-customerid="${items.userId}" data-permisstion="${rating_mine}"></input>
                                    </div>
                                  </div>
                                  ${renderComment(items, index, (_joIndex + '_closeJoinOrder'))}
                                 `
                                 joinedItemList += `<div class="form-check position-rel">
                                    <a href="#collapse_Closedietary_${index +'_'+_joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                        <span>Food preferences</span>
                                    </a>
                                    <div id="collapse_Closedietary_${index +'_'+_joIndex}" class="collapse"  style="margin-left: 30px; margin-top: 10px;">
                                        <ul>
                                            <li>`;
                                              if (items.dietaryPreferences && items.dietaryPreferences.length >0) {
                                                items.dietaryPreferences.forEach((item) => {
                                                  joinedItemList += `<p><i class="fa fa-lg fa-check-square-o"></i> ${item.name} </p>`
                                                });
                                              }
                                              joinedItemList += `</li>
                                        </ul>
                                    </div>
                                </div>`;



                                joinedItemList += `<div class="form-check position-rel">
                                    <a href="#collapse_cflavor_${index +'_'+_joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                        <span>Flavor preferences</span>
                                    </a>
                                    <div id="collapse_cflavor_${index +'_'+_joIndex}" class="restaurant-order-info collapse"  style="margin-left: 30px; margin-top: 10px;">
                                        ${ renderSensoryProfile(items.tasterProfile) }
                                    </div>
                                </div>`;

                                joinedItemList += `<div class="form-check position-rel">
                                  <a href="#collapse_closeFood_${index +'_'+_joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                      <span>Food Ordered</span>
                                  </a>
                                  <div id="collapse_closeFood_${index +'_'+_joIndex}" class="collapse in"  style="margin-left: 30px; margin-top: 10px;">
                                    <ul>`;
                                      if(items.userCartItems && items.userCartItems.length) {
                                        items.userCartItems.forEach((item) => {
                                        
                                          const itemExtendedPrice = item.extended_price.toFixed(2);
                                          //console.log("item.status ====",item.status)
                                          joinedItemList +=  item.status != 'cancelled' ? `<li>
                                                                <div class="row col-sm-12 col-md-12">
                                                                  <p class="text-success" style="margin:0">${item.menu_name} > ${item.section_name} ></p>
                                                                </div>
                                                                <div class="inline-flex-block cart-item-details" >
                                                                  <p><span class="item-name" >${item.item_name}</span> (<span class="item-quantity">${item.quantity} order${item.quantity > 1 ? 's' : ''}</span>)</p>
                                                                  <p>$<span data-unit-price="${item.retail_price} "class="item-price">${item.addons && item.addons.length > 0 ? parseFloat(sum_price_order(item)).toFixed(2) : itemExtendedPrice}</span> </p>
                                                                </div>
                                                              </li>`:`<li>
                                                                <div class="row col-sm-12 col-md-12">
                                                                  <p class="text-success" style="margin:0;text-decoration:line-through;">${item.menu_name} > ${item.section_name} ></p>
                                                                </div>
                                                                <div class="inline-flex-block cart-item-details" style="margin:0;text-decoration:line-through;">
                                                                  <p><span class="item-name"  >${item.item_name}</span> (<span class="item-quantity">${item.quantity} order${item.quantity > 1 ? 's' : ''}</span>)</p>
                                                                  <p>$<span data-unit-price="${item.retail_price} "class="item-price">${item.addons && item.addons.length > 0 ? parseFloat(sum_price_order(item)).toFixed(2) : itemExtendedPrice}</span> </p>
                                                                </div>
                                                              </li>`;

                                        });
                                      }
                                    joinedItemList += `
                                      <div>
                                        <div style="padding-left:100px;">
                                          <div class="form-inline" style="width: 250px;">
                                            <label style="width: 120px">Items Subtotal:</label>
                                            <label style="float:right">$ ${parseFloat(items.taxable_subtotal).toFixed(2)}</label>
                                          </div>
                                          <div class="form-inline" style="width: 250px;">
                                            <label style="width: 120px">Customer Convenience Fee:</label>
                                            <label style="float:right">$ ${items.convenience_fee_value ?(parseFloat(items.convenience_fee_value)).toFixed(2) : '0.00'}</label>
                                          </div>
                                          <div class="form-inline" style="width: 250px;">
                                            <label style="width: 120px">Taxes:</label>
                                            <label style="float:right">$ ${(parseFloat(items.taxAmount)).toFixed(2) || '0.00'}</label>
                                          </div>
                                          ${userCartOrder.orderType == 'delivery' ?
                                            `<div class="form-inline" style="width: 250px;">
                                              <label style="width: 120px">Delivery fee:</label>
                                              <label style="float:right">$ ${parseFloat(items.burq_delivery_fee && items.burq_delivery_fee>0 ? items.burq_delivery_fee : items.delivery_fee ).toFixed(2) }</label>
                                            </div>`
                                          : `` }
                                          <div class="form-inline" style="width: 250px;">
                                            <label style="width: 120px">Tip:</label>
                                            <label style="float:right;">$ ${items.tip_later == 'later' ? '(Later) ' : ''}${parseFloat(items.tip_amount + items.tip_platerate_free_food + items.tip_restaurant_free_food).toFixed(2) || '0.00'}</label>
                                          </div>
                                          <hr style="width: 250px; ">
                                          <div class="form-inline" style="width: 250px;">
                                            <label style="width: 120px">Total:</label>
                                            <label style="float:right">$ ${parseFloat(items.totalPrice).toFixed(2) || '0.00'}</label>
                                          </div>
                                        </div>
                                      </div>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                        `;
               _joIndex++;

       });


        let cliamOpiont = $('#servername-drop').html();
        let isCompleted = (userCartOrder.orderStatus == "completed");
        let label_order_time = [];
         if(userCartOrder.orderType == 'order-ahead'){
          label_order_time[0] = 'Reservation Requested';
          label_order_time[1] = 'Confirm Reservation';
          label_order_time[2] = 'Send order to kitchen';
          label_order_time[3] = 'Food/drink ready to serve';
          label_order_time[4] = 'Customer said they were in the restaurant';
         }else if(userCartOrder.orderType == 'delivery'){
          label_order_time[0] = 'Order placed';
          label_order_time[1] = 'Acknowledged';
          label_order_time[2] = 'Delivering';
          label_order_time[3] = 'Delivered (per restaurant)';
          label_order_time[4] = 'Delivered (per customer)';
         }else{
          label_order_time[0] = 'Order placed';
          label_order_time[1] = 'Acknowledged';
          label_order_time[2] = 'Ready for Pickup';
          label_order_time[3] = 'Picked up (per restaurant)';
          label_order_time[4] = 'Picked up (per customer)';
         }
         let day_remaining;
         if(userCartOrder.orderType == "order-ahead"){
          let time_begin = moment(userCartOrder.orderExpectedDate).format('MM/DD/YYYY') + ' ' + moment(userCartOrder.orderExpectedTime).format('hh:mm:a');
          let time_reserve = moment(time_begin).add(-userCartOrder.invitesDay, 'days');
          day_remaining = _.round(time_reserve.diff(moment(), 'hours')/24,2);
          if(day_remaining < 0) day_remaining = 0;
        }
        let orderHTML = `<div class="form-check position-rel restaurant-order-tree accord-box" id="item-list-order-${userCartOrder.orderId}" data-index="${index}" style="margin-bottom:50px;margin-top:50px;">
							<div class="accord-green">
							<h4 class="panel-title centerBlock">
							 <a href="#collapse_rClosedOrdersList_${index}" data-toggle="collapse" class="title-handle collapsed">
                                  <span class="order-name ">${(userCartOrder.orderName) ? userCartOrder.orderName : 'My Order'}</span>
                                  <span style="font-size: 1.7rem; "> ${(userCartOrder.totalOfAll && userCartOrder.totalOfAll>0) ? `  ($${userCartOrder.totalOfAll})` : '($0)'}</span>
                              </a>
							  </h4>
							  </div>
                              <div id="collapse_rClosedOrdersList_${index}" class="collapse" style="margin-left: 30px; margin-top: 10px;">
                                  <div class="form-check position-rel">

                                  <div style="padding-bottom:15px;">
                                    <b>Order number# ${userCartOrder.orderId}</b>
                                  </div>

                                  ${userCartOrder.orderType == 'order-ahead' ?
                                      `
                                      <div class="mb-3">
                                        <a href="#collapse_ahead_info_${userCartOrder.orderId}" data-toggle="collapse" class="title-handle collapsed" aria-expanded="true">
                                          <span> Reservation</span>
                                        </a>
                                        <div id="collapse_ahead_info_${userCartOrder.orderId}" class="collapse in" style="margin-left: 30px; margin-top: 10px;" aria-expanded="true">
                                          <div class="row">
                                              <label class="col-xs-6 col-sm-6 col-md-3">Total # of Reservation:</label>
                                              <label class="col-xs-6 col-sm-6 col-md-9">${userCartOrder.reserveSpace || 0}</label>
                                          </div>
                                          <div class="row">
                                              <label class="col-xs-6 col-sm-6 col-md-3"># Reserved:</label>
                                              <label class="col-xs-6 col-sm-6 col-md-9">${_.size(userCartOrder.orderChildren)}</label>
                                          </div>
                                          <div class="row">
                                              <label class="col-xs-6 col-sm-6 col-md-3">Reservation Date/Time:</label>
                                              <label class="col-xs-6 col-sm-6 col-md-9">${moment(userCartOrder.orderExpectedDate).format('M/DD/YY')}, ${moment(userCartOrder.orderExpectedTime).format('hh:mm:a')}</label>
                                          </div>
                                          <div class="row">
                                              <label class="col-xs-6 col-sm-6 col-md-3">Reservation Length:</label>
                                              <label class="col-xs-6 col-sm-6 col-md-9">${userCartOrder.reservationHours} hour(s) ${userCartOrder.reservationMinutes} minutes</label>
                                          </div>
                                          <div class="row">
                                              <label class="col-xs-6 col-sm-6 col-md-3">Days Remaining For people to reserve:</label>
                                              <label class="col-xs-6 col-sm-6 col-md-9">${day_remaining}</label>
                                          </div>
                                        </div>
                                      </div>
                                      `
                                    : ''}
                                      <a href="#collapse_closed_order_type_${index + _joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                          <span>Order type</span>
                                      </a>
                                      <div id="collapse_closed_order_type_${index + _joIndex}" class="collapse in"  style="margin-left: 30px; margin-top: 10px;">
                                          <ul>
                                             <li>
                                               ${(userCartOrder.orderType == "delivery") ?
                                                 `<p><i class="fa fa-lg fa-check-square-o"></i> Delivery</p>
                                                    ${(userCartOrder.serverId == null) ?
                                                      `<div style="margin-left:25px;"><i class="fa fa-lg fa-square-o"></i> Delivery person :
                                                        <button type="button" class="btn btn-sm btn-assign-order"
                                                          data-order-id="${userCartOrder.orderId}"
                                                          data-order-address="${userCartOrder.deliveryAddress}"
                                                          data-order-type="${userCartOrder.orderType}"
                                                          data-table-name="${userCartOrder.orderName}">Claim this order</button>
                                                        <p style="display: inline-block;">Assign to:</p>
                                                        <select class="form-control cliam_person" data-order-id="${userCartOrder.orderId}" data-order-address="${userCartOrder.deliveryAddress}" data-order-type="${userCartOrder.orderType}" data-table-name="${userCartOrder.orderName}" style="width: auto;display: inline-flex;">
                                                        ${cliamOpiont}
                                                        </select>
                                                      </div>`
                                                      :
                                                      `<p style="margin-left:30px;"><i class="fa fa-lg fa-check-square-o"></i> Delivery person : ${userCartOrder.serverName}</p>`
                                                    }`
                                                 :
                                                 '<p><i class="fa fa-lg fa-square-o"></i> Delivery</p>'
                                               }
                                               ${(userCartOrder.orderType == "pickup") ?
                                                 `<p><i class="fa fa-lg fa-check-square-o"></i> Pickup</p>`
                                                 :
                                                 '<p><i class="fa fa-lg fa-square-o"></i> Pickup</p>'
                                               }
                                                ${(userCartOrder.orderType == "order-ahead") ?
                                                `<p><i class="fa fa-lg fa-check-square-o"></i> Dine In</p>
                                                    <div class="edit-assign ${userCartOrder.serverId ? 'hidden': ''}" style="margin-left:25px;"><i class="fa fa-lg fa-square-o"></i> Waitstaff:
                                                      <button type="button" class="btn btn-sm btn-assign-order"
                                                        data-order-id="${userCartOrder.orderId}"
                                                        data-order-address="${userCartOrder.deliveryAddress}"
                                                        data-order-type="${userCartOrder.orderType}"
                                                        data-table-name="${userCartOrder.orderName}">Claim this order</button>
                                                      <p style="display: inline-block;">Assign to:</p>
                                                      <select class="form-control cliam_person" data-order-id="${userCartOrder.orderId}" data-order-address="${userCartOrder.deliveryAddress}" data-order-type="${userCartOrder.orderType}" data-table-name="${userCartOrder.orderName}" style="width: auto;display: inline-flex;">
                                                      </select>
                                                      ${userCartOrder.serverId
                                                        ? `<button type="button" class="btn btn-sm btn-cancel-assign" style="margin-left: 10px;">Cancel</button>`
                                                        : ''
                                                      }
                                                    </div>
                                                    <div class="show-assign ${userCartOrder.serverId ? '': 'hidden'}">
                                                      <p style="margin-left:30px;"><i class="fa fa-lg fa-check-square-o"></i> Waitstaff: ${userCartOrder.serverName} <button type="button" class="btn btn-xs btn-change-assign" data-assign-id="${userCartOrder.serverId}" style="margin-left: 10px;">Change</button></p>
                                                    </div>`
                                                :
                                                '<p><i class="fa fa-lg fa-square-o"></i> Dine In</p>'
                                                }
                                             </li>
                                          </ul>
                                      </div>
                                   </div>

                                   <div class="form-check position-rel mb-3">
                                       <a href="#collapse_closed_order_timing_${index + _joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                           <span>Order Timing</span>
                                       </a>
                                       <div id="collapse_closed_order_timing_${index + _joIndex}" class="collapse"  style="margin-left: 30px; margin-top: 10px;">
                                           <ul>
                                              <li>
                                                
                                                ${(userCartOrder.placedDate) ?
                                                `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[0]}: ${new Date(userCartOrder.placedDate).toLocaleString()}</p>`
                                                :
                                                `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[0]}</p>`
                                              }

                                                
                                                ${(userCartOrder.acknowledgedDate) ?
                                                  `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[1]}: ${moment.utc(userCartOrder.acknowledgedDate).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                  :
                                                  `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[1]}</p>`
                                                }
                                                ${userCartOrder.orderType == 'order-ahead' ?
                                                userCartOrder.arrivedDate ?
                                                  `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[4]}: ${moment.utc(userCartOrder.arrivedDate).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                  :
                                                  `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[4]}</p>`
                                                : ''}
                                                ${(userCartOrder.deliveringDate) ?
                                                  `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[2]}: ${moment.utc(userCartOrder.deliveringDate).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                  :
                                                  `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[2]}: </p>`
                                                }
                                                ${(userCartOrder.deliveredPerRestaurantDate) ?
                                                  `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[3]}: ${moment.utc(userCartOrder.deliveredPerRestaurantDate).utcOffset(UTC_OFFSET).format("hh:mm A")}</p>`
                                                  :
                                                  `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[3]}</p>`
                                                }
                                                ${userCartOrder.orderType != 'order-ahead' ?
                                                userCartOrder.deliveredPerCustomerDate ?
                                                  `<p><i class="fa fa-lg fa-check-square-o"></i> ${label_order_time[4]}: ${moment.utc(userCartOrder.deliveredPerCustomerDate).local().format("hh:mm A")}</p>`
                                                  :
                                                  `<p><i class="fa fa-lg fa-square-o"></i> ${label_order_time[4]}</p>`
                                                : ''}
                                              </li>
                                           </ul>
                                       </div>
                                   </div>
                              </div>
                          </div>
                          `;
        $orderListContainer.append(orderHTML);
        let $orderList        = $(`#collapse_rClosedOrdersList_${index}`);

        $orderList.append(joinedItemList);
        $(`#collapse_rClosedOrdersList_${index} .range-slider`).bootstrapSlider({
            min: 0,
            max: 100,
            range: true,
            enabled: false,
            values: [40, 60]
        });
      });
    } else { $orderListContainer.append(`<p class="grey">There are no orders.</p>`); }
    render_rating_customer('#restaurant-closed-orders-container')
  };

  function render_rating_customer(ele) {
    let rating_range = $(ele)
    rating_range.find('.rate-customer-overall').raterater({
      mode: 'input',
      allowChange: true,
      isStatic: true,
      spaceWidth: 2,
      starWidth: 20
    });
    rating_range.find('.rate-customer-mine').raterater({
      mode: 'input',
      allowChange: true,
      isStatic: false,
      spaceWidth: 2,
      starWidth: 20
    });
    rating_range.find('.rate-customer-mine').on('change',function(){
      let val_permisstion = $(this).data("permisstion");
      let data = {};
      data['user_id'] = $('#userId').val().trim();
      data['venue_id'] = $('#venueId').val().trim();
      data['rating'] = $(this).val().trim();
      data['customer_id'] = $(this).data('customerid').trim();
      if(isNaN(data['rating'])) return
      let _class = $(this).data("class");
      let rateting_update = $(`.${_class}`);
      $.ajax({
        url: '/orders/rateCustomerInOrders',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        error: function(err) {

          toastr.error('Failed to rate this customer!');
        },
        success: (res)=> {
          if(res.status == 403){
            let mine_update = rateting_update.find('.rating-customer-mine');
            mine_update.find('.rate-customer-mine').val(val_permisstion)
            mine_update.find('.raterater-input').remove()
            mine_update.find('.rate-customer-mine').raterater({
              mode: 'input',
              allowChange: true,
              isStatic: false,
              spaceWidth: 2,
              starWidth: 20
            });
            return toastr.warning("You aren't a restaurant staff member");
          }
          let overal_update = rateting_update.find('.rating-customer-overal');
          overal_update.find('.rate-customer-overall').val(res.data[0].AverageRating);
          overal_update.find('.raterater-input').remove()
          overal_update.find('.rate-customer-overall').raterater({
            mode: 'input',
            allowChange: true,
            isStatic: true,
            spaceWidth: 2,
            starWidth: 20
          });
          let num_reviews = res.data[0].ReviewsCounts;
          num_reviews > 1 ? num_reviews = num_reviews + ' reviews' : num_reviews = num_reviews + ' review';
          rateting_update.find('.num-reviews').text(num_reviews);
          let mine_update = rateting_update.find('.rating-customer-mine');
          mine_update.find('.rate-customer-mine').val(data['rating'])
          mine_update.find('.raterater-input').remove()
          mine_update.find('.rate-customer-mine').raterater({
            mode: 'input',
            allowChange: true,
            isStatic: false,
            spaceWidth: 2,
            starWidth: 20
          });
          toastr.success('Rate this customer successfully!');
        }
      })
    })
  }
  const renderComment = (cartOrder, index, _joIndex) => {
    let commentOrderHTML = `<div class="form-check position-rel mb-3 mt-3">
                            <a href="#collapse_order_comment_${index +'_'+_joIndex}" data-toggle="collapse" class="title-handle collapsed">
                                <span>Comments - </span>
                            </a>
                            <button class="btn btn-xs add_comments" id="commentBtn" type="button" style="color:black; font-size: 0.8em;" data-customer-id="${cartOrder.userId}">
                                Add comment
                            </button>
                            <div id="collapse_order_comment_${index +'_'+_joIndex}" class="collapse"  style="margin-left: 30px; margin-top: 10px;">
                              <ul class="order_comment_list_${cartOrder.userId}">`;
                              let _orderComments = cartOrder.comments;
                              if (_orderComments && _orderComments.length){
                                try {
                                  // let _orderComments = JSON.parse(`[${userCartOrder.comments}]`);
                                  _orderComments = _.orderBy(_orderComments, [(comment) => comment.created_on], ['desc']);
                                  if (_orderComments instanceof Array){
                                    _orderComments.forEach(c => {
                                      if (c.deleted_on == null){
                                        commentOrderHTML += `<li class="order-comment-${c.id}">
                                          <div class="form-check position-rel">
                                              <a href="#collapse_order_comment_${c.id}" data-toggle="collapse" class="title-handle collapsed"></a>
                                              <span style="font-size:16px;">
                                                  ${c.serverName} ${moment(c.created_on).format("MM/DD/YYYY hh:mm A")}
                                                  ${ USER_ID == c.posted_by
                                                    ? `<span class="edit-order-comment fa fa-lg fa fa-pencil-square green" data-comment-id=${c.id} data-customer-id=${c.posted_by}
                                                        style="cursor:pointer;"></span>
                                                      <span class="remove-order-comment fa fa-lg fa-times-circle red" data-comment-id=${c.id}
                                                        style="cursor:pointer;"></span>`
                                                    : ''}
                                                </span>
                                              <div id="collapse_order_comment_${c.id}" class="collapse in"  style="margin-left: 30px; margin-top: 10px;">
                                                <p><textarea readonly class="form-control">${c.comment}</textarea></p>
                                              </div>
                                          </div>
                                        </li>`
                                      }
                                    })
                                  }
                                } catch(e){
                                  console.log('=============', e);
                                }
                              }
                              commentOrderHTML += `</ul>
                            </div>
                          </div>`;
    return commentOrderHTML;
  }

  const renderSensoryProfile = (tasterProfile) => {
    if (!tasterProfile) return '';
    let html = ``;

    html += getSensoryProfileTemplate('Sweet', tasterProfile.sweet);
    html += getSensoryProfileTemplate('Salty', tasterProfile.salty);
    html += getSensoryProfileTemplate('Umami (meaty taste)', tasterProfile.savory);
    html += getSensoryProfileTemplate('Bitter', tasterProfile.bitter);
    html += getSensoryProfileTemplate('Sour', tasterProfile.sour);
    html += getSensoryProfileTemplate('Spicy', tasterProfile.spicy);
    html += getSensoryProfileTemplate('Healthy', tasterProfile.healthy);

    html += getSensoryProfileTemplate('Presentation', tasterProfile.presentation, {
      minText: 'Poor',
      maxText: 'Exceptional',
    });
    html += getSensoryProfileTemplate('Portion Size', tasterProfile.quantity, {

    });
    html += getSensoryProfileTemplate("What it's worth", tasterProfile.valueForPricing);

    return html;
  }

  const getSensoryProfileTemplate = (title, value, options = {}) => {
    return `<div class="row">
              <div class="col-12 col-sm-3 col-md-3">
                <label style="margin-top:0px; font-weight:500">${title}</label>
              </div>
              <div class="col-10 col-sm-6 col-md-6">
                <div class="row">
                  <div class="col-2"><span>${options.minText || 'Low'}</span></div>
                  <div class="col-8">
                    <input type="text" class="range-slider" data-provide="slider" value="${value.low},${value.high}" data-slider-value="[${value.low},${value.high}]" disabled/>
                  </div>
                  <div class="col-2"><span class="${ options.spanTextClass ? options.spanTextClass : '' }">${options.maxText || 'High'}</span></div>
                </div>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-2" style="margin-left:25px;">
                <label class="preference-items">
                  ${(value.low == 0 && value.high == 100)?
                    '<i class="fa fa-check-square" style="color:#02843d"></i>' : '<i class="fa fa-square-o" style="color:#02843d"></i>'}
                     N/A
                </label>
              </div>
            </div>`;
  }

  // $('#collapseRestaurantOrder').on('click', '.change-order-status-btn', function(e){
  //   let modalOrderId = $(this).data('order-id');
  //   $('#modal-order-id').val(modalOrderId);
  //   $('#change-order-status').modal();
  // })

  $('#collapseRestaurantOrder').on('click', '.decline-reservation-btn', function(e){
    const orderId = $(this).data('order-id');
    const seft = this;
    $(seft).prop('disabled', true);
    if(orderId) {
      $.ajax({
        url: '/orders/restaurant/paid/decline',
        type: 'POST',
        data: JSON.stringify({orderId: orderId}),
        contentType: 'application/json',
        dataType: 'json',
        error: function(err) {
          $(seft).prop('disabled', false);
          toastr.error('Failed get payment order!');
        },
        success: function(res) {
          $(seft).prop('disabled', false);
          if(res && res.data) {
            restaurantDecline(seft, res.data, orderId);
          } else {
            toastr.error('Failed get payment order!');
          }
        }
      });
    } else {
      toastr.error('Order not exists!');
    }
  })

  function restaurantDecline(seft, data, orderId) {
    let price = Number(data.total_price) > 0 ? Number(data.total_price) : 0;
    let numberPaid = data.numberPaid;
    const cancelOrder = function () {
      Swal.fire({
        title: 'Are you sure you want to decline?',
        text: `These customers have already paid for $${price.toFixed(2)} of food and ${numberPaid} people have RSVPd`,
        icon: "warning",
        allowOutsideClick: true,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }

    const buttonNames  = ["No" , "Yes"];
    const buttonColors = ["mediumseagreen", "#d43f3a"];
    if(orderId) {
      swalExtend.call(seft, {
        swalFunction: cancelOrder,
        hasCancelButton: true,
        buttonNum: 2,
        buttonColor: buttonColors,
        buttonNames: buttonNames,
        clickFunctionList: [
          function () { // no
          },
          function () {
            return $.ajax({
              url: '/orders/restaurant/decline',
              type: 'POST',
              data: JSON.stringify({orderId: orderId, venueId: VENUEID}),
              contentType: 'application/json',
              dataType: 'json',
              error: function(err) {
                toastr.error('Failed declined!');
              },
              success: function(res) {
                getRestaurantOrders()
                Swal.fire({
                  title: 'Successfully declined!',
                  text: '',
                  icon: "success",
                  showCancelButton: false,
                  showConfirmButton: true,
                });
              }
            })
          },
        ]
      });
    }
  }

  $('.restaurant-orders-nav').on('click', '.restaurant-order-type', function(e){
    $(this).parent().toggleClass("active");
    getRestaurantOrders();
  //  resetFetchInterval();
  })

function change_order_status(){
  $("body").on('click', '.change-order-status-btn', function (e) {
    
    let status  = $(this).data('value');
    let orderId = $(this).data('order-id');
    let orderType = $(this).data('order-type');
    let winwidth = $(window).width();
    let data = {
      orderId: orderId,
      venueId: VENUEID,
      status : status,
      orderType : orderType,
    }

    return $.ajax({
      url: '/orders/changeStatus',
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      dataType: 'json',
      error: function(err) {
        Swal.fire('Unable to change order status', 'Please Try Again!', 'error');
        toastr.error('Failed to change order status!');
      },
      success: function(res) {
        if (res.success){
          isChangeOrderStatus = true;
          getRestaurantOrders(false, true);
          const orderStep = getOrderStep(orderType);
          if(orderType == 'pickup'){
            if (orderStep === 1) orderStepLabel = 'Order Confirmed';
            else if (orderStep === 2) orderStepLabel = 'Sent to Kitchen';
            else if (orderStep === 3) orderStepLabel = 'Ready for Pickup';
            else if (orderStep > 3) orderStepLabel = 'Picked Up';

            $('#order_status').text(orderStepLabel)
            if(winwidth<480){ 
              renderBurgerStatus();
            }
          } else if(orderType == 'delivery'){
            getUIDegree(orderStep)
          }
          toastr.success('Order status changed!');
          if(data.status == 'completed'){
            let _date=$('#closed-order-date').data('DateTimePicker').date();
            getRestaurantClosedOrders();
          }
        } else {
          toastr.error(res.message);
        }
      }
    })
  })
}

  // ORDER COMMENTS FUNCTIONs
  /*Add commments to the databse */
  $('body').on("click", ".add_comments", function(e){
    const customerId = $(this).data('customer-id');
    $("#add-comment .customer_id").val(customerId);
    $("#add-comment .comment_id").val('');
    $("#add-comment .comment").val('');
    $("#add-comment").modal();
  });

  $('body').on("click", ".edit-order-comment", function(e){
    const customerId = $(this).data('customer-id');
    const comment_id = $(this).data('comment-id');
    const contentComment = $.trim($('.order-comment-'+comment_id).find('textarea').val());
    $("#add-comment .customer_id").val(customerId);
    $("#add-comment .comment_id").val(comment_id);
    $("#add-comment .comment").val(contentComment);
    $("#add-comment").modal();
  });

  /*Save Modal */
  $('.save-comment').on('click', function () {
    const currentCustomerId = $("#add-comment .customer_id").val();
    const commentText    = $.trim($("#add-comment .comment").val());
    const commentId    = $.trim($("#add-comment .comment_id").val());
    var saveComment = {
      comment: commentText,
      customerId: currentCustomerId,
      commentId: commentId,
    };
    $.ajax({
      url: `/restaurantadmin/saveOrderComments`,
      type: 'POST',
      data: JSON.stringify(saveComment),
      contentType: 'application/json; charset=utf-8',
      success: function(res) {
        if (res.ok != 0 && res.data[0]){
          if(commentId) {
            $('.order-comment-'+commentId).find('textarea').val(commentText);
          } else {
            const comment = res.data[0];
            let commentHTML = `<li class="order-comment-${comment.id}">
                                 <div class="form-check position-rel">
                                     <a href="#collapse_order_comment_${comment.id}" data-toggle="collapse" class="title-handle collapsed"></a>
                                     <span style="font-size:16px;">
                                        ${comment.serverName} ${moment(comment.created_on).format("MM/DD/YYYY hh:mm A")}
                                        <span class="edit-order-comment fa fa-lg fa fa-pencil-square green" data-comment-id=${comment.id} data-customer-id=${saveComment.customerId}
                                          style="cursor:pointer;"></span>
                                        <span class="remove-order-comment fa fa-lg fa-times-circle red" data-comment-id=${comment.id}
                                          style="cursor:pointer;"></span>
                                      </span>
                                     <div id="collapse_order_comment_${comment.id}" class="collapse in"  style="margin-left: 30px; margin-top: 10px;">
                                       <p>
                                       <textarea readonly class="form-control">${comment.comment}</textarea>
                                       </p>
                                     </div>
                                 </div>
                              </li>`;
            $("#collapseRestaurantOrder").find(`.order_comment_list_${currentCustomerId}`).prepend(commentHTML);
          }
          toastr.success("Success");
        }
        else {
          Swal.fire('Unable to save comments', 'Please Try Again!', 'error');
        }
      },
      error: function(err) {
        Swal.fire('Failed to save', 'Please Try Again!', 'error');
      },

    });
  })

  /*Remove  commments to the databse */
  $('body').on("click", ".remove-order-comment", function(e){
    var order_comment = $(this).data('comment-id');
    Swal.fire({
      title: 'Are you sure you want to remove this comment ?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      confirmButtonColor: '#3cb371',
      cancelButtonText: 'No',
      cancelButtonColor: '#d9534f',
    }).then((result) => {
          if (result.isConfirmed) {
       
      $.ajax({
        url: `/restaurantadmin/removeComment`,
        method: 'POST',
        data: JSON.stringify({commentId :order_comment }),
        contentType: 'application/json; charset=utf-8',
        success: function (response) {
          $(`.order-comment-${order_comment}`).remove();
          toastr.success("Removed successfully");
        },
        error: function (err) {
          Swal.fire("Error!", '', "err");

        },
      });
    }
    });
  });

  // Claim order
  $('body').on('click', '.btn-assign-order', function () {
    let order_id = $(this).data('order-id');
    let tableName = $(this).data('table-name');
    var address = $(this).data('order-address');
    var orderType = $(this).data('order-type');
    let status = 'ordered'; // temporaray
    let claimTable = {
      tableName: tableName,
      orderType: orderType,
      address: address,
      serverId: USER_ID,
      venueId: $('#venueId').val(),
      orderId : order_id,
      status : status,
    };
    if(!claimTable.serverId) {
      Swal.fire("", 'Please select a Server/ Delivery person', "warning");
      return false;
    }
    claimOrder(claimTable)
  });

  $('body').on('change', '.cliam_person', function () {
    let order_id = $(this).data('order-id');
    let tableName = $(this).data('table-name');
    var address = $(this).data('order-address');
    var orderType = $(this).data('order-type');
    let server_id = $(this).val();
    var personType = $(this).find('option:selected').data('type');
    let status = 'ordered'; // temporaray
    let claimTable = {
      tableName: tableName,
      orderType: orderType,
      address: address,
      serverId: server_id,
      venueId: $('#venueId').val(),
      orderId : order_id,
      status : status,
      personType: personType
    };
    if(!server_id) {
      Swal.fire("", 'Please select a Server/ Delivery person', "warning");
      return false;
    }
    claimOrder(claimTable)
  });

  function claimOrder (claimTable) {
    $.ajax({
      url: `/restaurantadmin/assignOrders`,
      method: 'POST',
      data: JSON.stringify(claimTable),
      contentType: 'application/json; charset=utf-8',
      success: function (response) {
        Swal.fire("Success!", '', "success");
        getRestaurantOrders(claimTable.orderId);
      },
      error: function (err) {
        Swal.fire("Sorry this order is assignjed to other server!", '', "err");
      },
    });
  }

  let orderId = url.searchParams.get('orderId');
  let orderType = url.searchParams.get('orderType');
  if(show == 'RestaurantOrder' && orderId && orderType) {
    /*This code commented for order type buttons keep selected when open link restaurant staff from flexnotification*/
    // $('.order-type-li.active').removeClass('active')
    // $('.order-type-li').find(`.${orderType}`).parent().addClass('active')

    getRestaurantOrders(orderId,true,true);
    $('.rest_btn_container').find('a').removeClass('active')
    $('.rest_btn_container').find(`a[data-point-to="#restaurant-orders"]`).addClass('active')
    $(`#restaurant-orders`).show();
  }

  $('.order-type-li').click(function(e){
    let $target = $(e.currentTarget)
    if (!$target.hasClass('active')){
      if ($target.hasClass('waitlist')){
        $('.order-type-li:not(.waitlist)').removeClass('active')
        $('#restaurant-waitlist-queue-container').show()
        $('#restaurant-orders-container').hide()
        refreshRestaurantWaitlistTable(VENUEID)
      } else {
        $('.order-type-li.waitlist').removeClass('active')
        $('#restaurant-waitlist-queue-container').hide()
        $('#restaurant-orders-container').show()
      }
    }
  })




	$("body").on("click",".removeRequest", function(){
		let venueId = $(this).data("venueid");
		let data = {
			venueId : $(this).data("venueid"),
		  orderId : $(this).data("orderid"),
		  customerId : $(this).data("customerid"),
		  urgentType : $(this).data("urgenttype"),
		}
		$.ajax({
      url: `/restaurantadmin/deleteServerReq`,
      method: 'POST',
      data: JSON.stringify(data),
			dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: function (results) {
				if(results && results.code == 1){
					Swal.fire("Success", results.message, "success");
				} else {
					Swal.fire("Oops", results.message, "error");
				}
				getServerRequests();
			}
		});
	});
//
})
//Refresh new order notification
const OrderRestaurant = (() => {
  const refreshNewOrder = (venueId) => {
    if (VENUEID == venueId){
      getRestaurantOrders();
      getRestaurantClosedOrders();
    }
  };

  let audio;
  let audioFile;
 /* function initAudioNotification(){
    $.ajax({
      url: `/restaurantadmin/alarmNotification?venueId=${VENUEID}`,
      method: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: function (res) {
        const sound = res && res.sound || "Please Confirm Platerate Order.m4a";
        const filePath = '/sounds?serve=' + sound;

        if (audioFile != filePath) { // if file change or not initialized, update source
          if (audio) audio.pause();
          audio = new Audio(filePath);
          audioFile = filePath;
          audio.volume = 0.2;
          audio.onended = function() {
            audio.play();
            if ( audio.volume < 1 ) audio.volume += 0.1;
          };
        }

        if (audioFile == filePath){ // same file, another order came in, do not replay audio
          if (audio.paused) audio.play();
        } else {
          audio.play();
        }

      }
    });
  }*/


  // Load Idle sound, if restaurant order tab is visible
  if ($( ".open-restaurant-orders" ).length > 0){
    let audioIdle = new Audio('/sounds?serve=idle.mp3');
    audioIdle.loop = true;
    audioIdle.volume = 0.1;
    audioIdle.play();
    audioIdle.pause();
    setTimeout(function(){
      audioIdle.play();
    }, 5000)
  }
 const pushChangeOrderTime = (data)=>{

    let url=window.location.href;
    const array = url.split('/');
    const lastsegment = array[array.length-1];
    console.log("lastsegment========",lastsegment)
    console.log("VENUE_ID========",data.data)
    if (lastsegment == data.data.orderId){
     // $('#order-ahead-date').val(moment(data.order_expected_date).format('MM/DD/YYYY h:mm A'));
      var dateReservationTime = moment(data.data.newdatetime).format('MM/DD/YYYY h:mm A');
      console.log("dateReservationTime=11===",dateReservationTime)
      var timezoneval=$("#timezoneid").val();

      var estimated_pickuptime=dateReservationTime;
      console.log("dateReservationTime==11=",estimated_pickuptime)
      Swal.fire({
        title: "Order expected time was updated",
        text: `New estimated time is ${estimated_pickuptime}`,
        icon: "success"
      }).then(() => {
        location.reload();
      });
    }
  }
  const pushOrderAlarm = (body) => {
    if (VENUEID == body.targetVenueId){
      initAudioNotification();

      if (!$(".open-restaurant-orders").hasClass("active")){
        getRestaurantOrders();
        $(".open-restaurant-orders").trigger('click');
      }

      Swal.fire({
          title: "Confirm Order?",
          icon: "warning",
          showCancelButton: true,
          showConfirmButton:true,
          allowOutsideClick:true,
      }).then((result) => {
        if(result.isConfirmed){
          audio.pause();
          audio.load();
          audio.volume = 0.2;
        }
          
      })
    }
  };
  //Public methods
  return {
    refreshNewOrder,
    pushOrderAlarm,
    pushChangeOrderTime
  }
})();
